function PlanNN({ ...props }) {
	return (
		<g {...props} id="unit-nn">
			<g id="furniture">
				<polyline
					points="612.16 621.88 612.16 619.18 613.53 619.18 613.53 621.88 612.16 621.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="346.1"
					y1="560.11"
					x2="366.65"
					y2="560.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.1"
					y1="477.64"
					x2="346.1"
					y2="560.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="477.64"
					x2="346.1"
					y2="477.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="560.11"
					x2="366.65"
					y2="556.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="554.71"
					x2="366.65"
					y2="551.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="549.45"
					x2="366.65"
					y2="546.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="544.19"
					x2="366.65"
					y2="540.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="538.93"
					x2="366.65"
					y2="535.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="533.67"
					x2="366.65"
					y2="530.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="528.41"
					x2="366.65"
					y2="525.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="523.15"
					x2="366.65"
					y2="519.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="517.89"
					x2="366.65"
					y2="514.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="491.59"
					x2="366.65"
					y2="488.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="486.33"
					x2="366.65"
					y2="483.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="481.07"
					x2="366.65"
					y2="477.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="477.64"
					x2="363.31"
					y2="477.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.33"
					y1="477.64"
					x2="358.05"
					y2="477.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.07"
					y1="477.64"
					x2="352.79"
					y2="477.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.82"
					y1="477.64"
					x2="347.47"
					y2="477.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="477.64"
					x2="347.47"
					y2="481.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="483.05"
					x2="347.47"
					y2="486.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="488.31"
					x2="347.47"
					y2="491.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="493.56"
					x2="347.47"
					y2="496.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="498.82"
					x2="347.47"
					y2="502.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="504.09"
					x2="347.47"
					y2="507.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="509.34"
					x2="347.47"
					y2="512.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="514.6"
					x2="347.47"
					y2="517.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="519.86"
					x2="347.47"
					y2="523.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="525.12"
					x2="347.47"
					y2="528.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="530.38"
					x2="347.47"
					y2="533.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="535.64"
					x2="347.47"
					y2="538.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="540.9"
					x2="347.47"
					y2="544.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="546.16"
					x2="347.47"
					y2="549.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="551.42"
					x2="347.47"
					y2="554.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="556.68"
					x2="347.47"
					y2="560.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.47"
					y1="560.11"
					x2="350.82"
					y2="560.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.79"
					y1="560.11"
					x2="356.07"
					y2="560.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.05"
					y1="560.11"
					x2="361.33"
					y2="560.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.31"
					y1="560.11"
					x2="366.65"
					y2="560.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.38"
					y1="326.22"
					x2="733.38"
					y2="427.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.41"
					y1="326.22"
					x2="726.69"
					y2="326.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.67"
					y1="326.22"
					x2="732.01"
					y2="326.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="326.22"
					x2="732.01"
					y2="328.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="330.73"
					x2="732.01"
					y2="334.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="335.99"
					x2="732.01"
					y2="339.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="341.25"
					x2="732.01"
					y2="344.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="346.51"
					x2="732.01"
					y2="349.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="351.77"
					x2="732.01"
					y2="355.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="357.03"
					x2="732.01"
					y2="360.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="362.28"
					x2="732.01"
					y2="365.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="367.54"
					x2="732.01"
					y2="370.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="372.8"
					x2="732.01"
					y2="376.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="378.06"
					x2="732.01"
					y2="381.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="383.32"
					x2="732.01"
					y2="386.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="388.58"
					x2="732.01"
					y2="391.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="393.84"
					x2="732.01"
					y2="397.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="399.1"
					x2="732.01"
					y2="402.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="404.36"
					x2="732.01"
					y2="407.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="409.62"
					x2="732.01"
					y2="412.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="414.88"
					x2="732.01"
					y2="418.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="420.14"
					x2="732.01"
					y2="423.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="425.4"
					x2="732.01"
					y2="427.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.01"
					y1="427.94"
					x2="728.67"
					y2="427.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="717.82 536.54 717.82 661.45 614.9 661.45 614.9 628.58 684.94 628.58 684.94 536.54 717.82 536.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="717.82"
					y1="536.54"
					x2="717.82"
					y2="661.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.82"
					y1="661.45"
					x2="614.9"
					y2="661.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.9"
					y1="628.58"
					x2="684.94"
					y2="628.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.94"
					y1="628.58"
					x2="684.94"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="517.05 634.19 554.03 634.19 554.03 671.17 517.05 671.17 517.05 634.19"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="73.53 362.22 76.33 354.58 80.06 347.34 84.65 340.62 90.04 334.51 96.15 329.12 102.87 324.53 110.11 320.8 117.75 318 123.91 316.48 130.19 315.56 136.53 315.26 701.88 315.26 701.88 318 136.53 318 128.94 318.46 121.45 319.83 114.19 322.09 107.25 325.21 100.74 329.15 94.75 333.84 89.37 339.22 84.68 345.21 80.74 351.72 77.62 358.66 75.36 365.92 73.99 373.41 73.53 381 73.53 445.21 70.79 448.01 70.79 381 71.09 374.66 72.01 368.38 73.53 362.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="73.53"
					y1="362.22"
					x2="72.01"
					y2="368.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="72.01"
					y1="368.38"
					x2="71.09"
					y2="374.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="71.09"
					y1="374.66"
					x2="70.79"
					y2="381"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="70.79"
					y1="381"
					x2="70.79"
					y2="448.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="70.79"
					y1="448.01"
					x2="73.53"
					y2="445.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="73.53"
					y1="445.21"
					x2="73.53"
					y2="381"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="73.53"
					y1="381"
					x2="73.99"
					y2="373.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="73.99"
					y1="373.41"
					x2="75.36"
					y2="365.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="75.36"
					y1="365.92"
					x2="77.62"
					y2="358.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="77.62"
					y1="358.66"
					x2="80.74"
					y2="351.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="80.74"
					y1="351.72"
					x2="84.68"
					y2="345.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.68"
					y1="345.21"
					x2="89.37"
					y2="339.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.37"
					y1="339.22"
					x2="94.75"
					y2="333.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.75"
					y1="333.84"
					x2="100.74"
					y2="329.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="100.74"
					y1="329.15"
					x2="107.25"
					y2="325.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.25"
					y1="325.21"
					x2="114.19"
					y2="322.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="114.19"
					y1="322.09"
					x2="121.45"
					y2="319.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="121.45"
					y1="319.83"
					x2="128.94"
					y2="318.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.94"
					y1="318.46"
					x2="136.53"
					y2="318"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.53"
					y1="318"
					x2="701.88"
					y2="318"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.88"
					y1="318"
					x2="701.88"
					y2="315.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.88"
					y1="315.26"
					x2="136.53"
					y2="315.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="136.53"
					y1="315.26"
					x2="130.19"
					y2="315.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.19"
					y1="315.56"
					x2="123.91"
					y2="316.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="123.91"
					y1="316.48"
					x2="117.75"
					y2="318"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="117.75"
					y1="318"
					x2="110.11"
					y2="320.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.11"
					y1="320.8"
					x2="102.87"
					y2="324.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="102.87"
					y1="324.53"
					x2="96.15"
					y2="329.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.15"
					y1="329.12"
					x2="90.04"
					y2="334.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="90.04"
					y1="334.51"
					x2="84.65"
					y2="340.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.65"
					y1="340.62"
					x2="80.06"
					y2="347.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="80.06"
					y1="347.34"
					x2="76.33"
					y2="354.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="76.33"
					y1="354.58"
					x2="73.53"
					y2="362.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="294.69 423.29 272.1 423.29 272.1 426.26 294.69 426.26 294.69 423.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="271.02 423.02 295.77 423.02 295.77 423.29 271.02 423.29 271.02 423.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="271.02"
					y1="423.02"
					x2="295.77"
					y2="423.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="295.77"
					y1="423.02"
					x2="295.77"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="295.77"
					y1="423.29"
					x2="271.02"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.02"
					y1="423.29"
					x2="271.02"
					y2="423.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.69"
					y1="426.26"
					x2="272.1"
					y2="426.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.1"
					y1="423.29"
					x2="294.69"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="297.12 426.26 294.69 426.26 294.69 423.29 297.12 423.29 297.12 426.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="297.12"
					y1="426.26"
					x2="294.69"
					y2="426.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.69"
					y1="426.26"
					x2="294.69"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.69"
					y1="423.29"
					x2="297.12"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.12"
					y1="423.29"
					x2="297.12"
					y2="426.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="269.67 423.29 272.1 423.29 272.1 426.26 269.67 426.26 269.67 423.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="269.67"
					y1="423.29"
					x2="272.1"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.1"
					y1="423.29"
					x2="272.1"
					y2="426.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.1"
					y1="426.26"
					x2="269.67"
					y2="426.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.67"
					y1="426.26"
					x2="269.67"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.69"
					y1="423.83"
					x2="272.1"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="298.2 425.99 297.12 425.99 297.12 423.29 295.77 423.29 295.77 423.02 298.2 423.02 298.2 425.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="298.2"
					y1="425.99"
					x2="297.12"
					y2="425.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.12"
					y1="425.99"
					x2="297.12"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.12"
					y1="423.29"
					x2="295.77"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="295.77"
					y1="423.29"
					x2="295.77"
					y2="423.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="295.77"
					y1="423.02"
					x2="298.2"
					y2="423.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.2"
					y1="423.02"
					x2="298.2"
					y2="425.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="268.59 423.02 271.02 423.02 271.02 423.29 269.67 423.29 269.67 425.99 268.59 425.99 268.59 423.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="268.59"
					y1="423.02"
					x2="271.02"
					y2="423.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.02"
					y1="423.02"
					x2="271.02"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.02"
					y1="423.29"
					x2="269.67"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.67"
					y1="423.29"
					x2="269.67"
					y2="425.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.67"
					y1="425.99"
					x2="268.59"
					y2="425.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.59"
					y1="425.99"
					x2="268.59"
					y2="423.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="267.22 423.83 267.22 425.2 210.6 425.2 210.6 423.83 267.22 423.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="267.22"
					y1="423.83"
					x2="267.22"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.22"
					y1="425.2"
					x2="210.6"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.6"
					y1="425.2"
					x2="210.6"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.6"
					y1="423.83"
					x2="267.22"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="298.2 423.83 300.94 423.83 300.94 432.05 298.2 432.05 298.2 423.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="300.94"
					y1="423.83"
					x2="298.2"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.94"
					y1="432.05"
					x2="300.94"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.2"
					y1="432.05"
					x2="300.94"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.2"
					y1="423.83"
					x2="298.2"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="265.85 423.83 268.59 423.83 268.59 432.05 265.85 432.05 265.85 423.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="268.59"
					y1="423.83"
					x2="265.85"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.59"
					y1="432.05"
					x2="268.59"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.85"
					y1="432.05"
					x2="268.59"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.85"
					y1="423.83"
					x2="265.85"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="209.23 423.83 211.97 423.83 211.97 432.05 209.23 432.05 209.23 423.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="211.97"
					y1="423.83"
					x2="209.23"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.97"
					y1="432.05"
					x2="211.97"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.23"
					y1="432.05"
					x2="211.97"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.23"
					y1="423.83"
					x2="209.23"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="652.82 423.29 630.7 423.29 630.7 426.26 652.82 426.26 652.82 423.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="629.62 423.02 653.9 423.02 653.9 423.29 629.62 423.29 629.62 423.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="629.62"
					y1="423.02"
					x2="653.9"
					y2="423.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="653.9"
					y1="423.02"
					x2="653.9"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="653.9"
					y1="423.29"
					x2="629.62"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.62"
					y1="423.29"
					x2="629.62"
					y2="423.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.82"
					y1="426.26"
					x2="630.7"
					y2="426.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.7"
					y1="423.29"
					x2="652.82"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="655.25 426.26 652.82 426.26 652.82 423.29 655.25 423.29 655.25 426.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="655.25"
					y1="426.26"
					x2="652.82"
					y2="426.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.82"
					y1="426.26"
					x2="652.82"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.82"
					y1="423.29"
					x2="655.25"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.25"
					y1="423.29"
					x2="655.25"
					y2="426.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="628.27 423.29 630.7 423.29 630.7 426.26 628.27 426.26 628.27 423.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="628.27"
					y1="423.29"
					x2="630.7"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.7"
					y1="423.29"
					x2="630.7"
					y2="426.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.7"
					y1="426.26"
					x2="628.27"
					y2="426.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.27"
					y1="426.26"
					x2="628.27"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.82"
					y1="423.83"
					x2="630.7"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="656.33 425.99 655.25 425.99 655.25 423.29 653.9 423.29 653.9 423.02 656.33 423.02 656.33 425.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="656.33"
					y1="425.99"
					x2="655.25"
					y2="425.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.25"
					y1="425.99"
					x2="655.25"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.25"
					y1="423.29"
					x2="653.9"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="653.9"
					y1="423.29"
					x2="653.9"
					y2="423.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="653.9"
					y1="423.02"
					x2="656.33"
					y2="423.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.33"
					y1="423.02"
					x2="656.33"
					y2="425.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="627.19 423.02 629.62 423.02 629.62 423.29 628.27 423.29 628.27 425.99 627.19 425.99 627.19 423.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="627.19"
					y1="423.02"
					x2="629.62"
					y2="423.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.62"
					y1="423.02"
					x2="629.62"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.62"
					y1="423.29"
					x2="628.27"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.27"
					y1="423.29"
					x2="628.27"
					y2="425.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.27"
					y1="425.99"
					x2="627.19"
					y2="425.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.19"
					y1="425.99"
					x2="627.19"
					y2="423.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="625.82 423.83 625.82 425.2 577.59 425.2 577.59 423.83 625.82 423.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="625.82"
					y1="423.83"
					x2="625.82"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.82"
					y1="425.2"
					x2="577.59"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.59"
					y1="425.2"
					x2="577.59"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.59"
					y1="423.83"
					x2="625.82"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="656.33 423.83 659.07 423.83 659.07 432.05 656.33 432.05 656.33 423.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="659.07"
					y1="423.83"
					x2="656.33"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.07"
					y1="432.05"
					x2="659.07"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.33"
					y1="432.05"
					x2="659.07"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.33"
					y1="423.83"
					x2="656.33"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="624.45 423.83 627.19 423.83 627.19 432.05 624.45 432.05 624.45 423.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="627.19"
					y1="423.83"
					x2="624.45"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.19"
					y1="432.05"
					x2="627.19"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.45"
					y1="432.05"
					x2="627.19"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.45"
					y1="423.83"
					x2="624.45"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="576.23 423.83 578.96 423.83 578.96 432.05 576.23 432.05 576.23 423.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="578.96"
					y1="423.83"
					x2="576.23"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.96"
					y1="432.05"
					x2="578.96"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.23"
					y1="432.05"
					x2="578.96"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.23"
					y1="423.83"
					x2="576.23"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="878.59 317.46 856.47 317.46 856.47 320.42 878.59 320.42 878.59 317.46"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="855.39 317.19 879.67 317.19 879.67 317.46 855.39 317.46 855.39 317.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="855.39"
					y1="317.19"
					x2="879.67"
					y2="317.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.67"
					y1="317.19"
					x2="879.67"
					y2="317.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.67"
					y1="317.46"
					x2="855.39"
					y2="317.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.39"
					y1="317.46"
					x2="855.39"
					y2="317.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="878.59"
					y1="320.42"
					x2="856.47"
					y2="320.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.47"
					y1="317.46"
					x2="878.59"
					y2="317.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="881.02 320.42 878.59 320.42 878.59 317.46 881.02 317.46 881.02 320.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="881.02"
					y1="320.42"
					x2="878.59"
					y2="320.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="878.59"
					y1="320.42"
					x2="878.59"
					y2="317.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="878.59"
					y1="317.46"
					x2="881.02"
					y2="317.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.02"
					y1="317.46"
					x2="881.02"
					y2="320.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="854.04 317.46 856.47 317.46 856.47 320.42 854.04 320.42 854.04 317.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="854.04"
					y1="317.46"
					x2="856.47"
					y2="317.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.47"
					y1="317.46"
					x2="856.47"
					y2="320.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.47"
					y1="320.42"
					x2="854.04"
					y2="320.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.04"
					y1="320.42"
					x2="854.04"
					y2="317.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="878.59"
					y1="318"
					x2="856.47"
					y2="318"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="882.1 320.15 881.02 320.15 881.02 317.46 879.67 317.46 879.67 317.19 882.1 317.19 882.1 320.15"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="882.1"
					y1="320.15"
					x2="881.02"
					y2="320.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.02"
					y1="320.15"
					x2="881.02"
					y2="317.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.02"
					y1="317.46"
					x2="879.67"
					y2="317.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.67"
					y1="317.46"
					x2="879.67"
					y2="317.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.67"
					y1="317.19"
					x2="882.1"
					y2="317.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.1"
					y1="317.19"
					x2="882.1"
					y2="320.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="852.96 317.19 855.39 317.19 855.39 317.46 854.04 317.46 854.04 320.15 852.96 320.15 852.96 317.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="852.96"
					y1="317.19"
					x2="855.39"
					y2="317.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.39"
					y1="317.19"
					x2="855.39"
					y2="317.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.39"
					y1="317.46"
					x2="854.04"
					y2="317.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.04"
					y1="317.46"
					x2="854.04"
					y2="320.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.04"
					y1="320.15"
					x2="852.96"
					y2="320.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="852.96"
					y1="320.15"
					x2="852.96"
					y2="317.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="851.59 318 851.59 319.37 779.11 319.37 779.11 318 851.59 318"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="851.59"
					y1="318"
					x2="851.59"
					y2="319.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="851.59"
					y1="319.37"
					x2="779.11"
					y2="319.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.11"
					y1="319.37"
					x2="779.11"
					y2="318"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.11"
					y1="318"
					x2="851.59"
					y2="318"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="882.1 318 884.84 318 884.84 326.22 882.1 326.22 882.1 318"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="884.84"
					y1="318"
					x2="882.1"
					y2="318"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.84"
					y1="326.22"
					x2="884.84"
					y2="318"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.1"
					y1="326.22"
					x2="884.84"
					y2="326.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.1"
					y1="318"
					x2="882.1"
					y2="326.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="850.22 318 852.96 318 852.96 326.22 850.22 326.22 850.22 318"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="852.96"
					y1="318"
					x2="850.22"
					y2="318"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="852.96"
					y1="326.22"
					x2="852.96"
					y2="318"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="850.22"
					y1="326.22"
					x2="852.96"
					y2="326.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="850.22"
					y1="318"
					x2="850.22"
					y2="326.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="777.74 318 780.48 318 780.48 326.22 777.74 326.22 777.74 318"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="780.48"
					y1="318"
					x2="777.74"
					y2="318"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.48"
					y1="326.22"
					x2="780.48"
					y2="318"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.74"
					y1="326.22"
					x2="780.48"
					y2="326.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.74"
					y1="318"
					x2="777.74"
					y2="326.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="503.92 416.82 503.92 380.65 506.61 380.65 506.61 416.82 503.92 416.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="503.92"
					y1="416.82"
					x2="503.92"
					y2="380.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.92"
					y1="380.65"
					x2="506.61"
					y2="380.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.61"
					y1="380.65"
					x2="506.61"
					y2="416.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.61"
					y1="416.82"
					x2="503.92"
					y2="416.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.07"
					y1="416.82"
					x2="506.07"
					y2="380.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.61"
					y1="416.82"
					x2="506.61"
					y2="380.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.92"
					y1="416.82"
					x2="503.92"
					y2="380.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="503.92 423.29 503.92 416.82 506.61 416.82 506.61 423.29 503.92 423.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="503.92"
					y1="423.29"
					x2="503.92"
					y2="416.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.92"
					y1="416.82"
					x2="506.61"
					y2="416.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.61"
					y1="416.82"
					x2="506.61"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.61"
					y1="423.29"
					x2="503.92"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="503.92 380.65 503.92 374.18 506.61 374.18 506.61 380.65 503.92 380.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="503.92"
					y1="380.65"
					x2="503.92"
					y2="374.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.92"
					y1="374.18"
					x2="506.61"
					y2="374.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.61"
					y1="374.18"
					x2="506.61"
					y2="380.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.61"
					y1="380.65"
					x2="503.92"
					y2="380.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="507.69 426.26 505.26 426.26 505.26 425.99 506.61 425.99 506.61 423.29 507.69 423.29 507.69 426.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="507.69"
					y1="426.26"
					x2="505.26"
					y2="426.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.26"
					y1="426.26"
					x2="505.26"
					y2="425.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.26"
					y1="425.99"
					x2="506.61"
					y2="425.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.61"
					y1="425.99"
					x2="506.61"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.61"
					y1="423.29"
					x2="507.69"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.69"
					y1="423.29"
					x2="507.69"
					y2="426.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="456.42 423.29 457.5 423.29 457.5 425.99 458.85 425.99 458.85 426.26 456.42 426.26 456.42 423.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="456.42"
					y1="423.29"
					x2="457.5"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.5"
					y1="423.29"
					x2="457.5"
					y2="425.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.5"
					y1="425.99"
					x2="458.85"
					y2="425.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.85"
					y1="425.99"
					x2="458.85"
					y2="426.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.85"
					y1="426.26"
					x2="456.42"
					y2="426.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.42"
					y1="426.26"
					x2="456.42"
					y2="423.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="455.05 423.83 455.05 425.2 404.7 425.2 404.7 423.83 455.05 423.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="455.05"
					y1="423.83"
					x2="455.05"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.05"
					y1="425.2"
					x2="404.7"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="404.7"
					y1="425.2"
					x2="404.7"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="404.7"
					y1="423.83"
					x2="455.05"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="507.69 423.83 510.43 423.83 510.43 432.05 507.69 432.05 507.69 423.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="510.43"
					y1="423.83"
					x2="507.69"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.43"
					y1="432.05"
					x2="510.43"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.69"
					y1="432.05"
					x2="510.43"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.69"
					y1="423.83"
					x2="507.69"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="453.68 423.83 456.42 423.83 456.42 432.05 453.68 432.05 453.68 423.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="456.42"
					y1="423.83"
					x2="453.68"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.42"
					y1="432.05"
					x2="456.42"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.68"
					y1="432.05"
					x2="456.42"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.68"
					y1="423.83"
					x2="453.68"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="403.33 423.83 406.07 423.83 406.07 432.05 403.33 432.05 403.33 423.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="406.07"
					y1="423.83"
					x2="403.33"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.07"
					y1="432.05"
					x2="406.07"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.33"
					y1="432.05"
					x2="406.07"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.33"
					y1="423.83"
					x2="403.33"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="62.21 463.87 63.53 464.24 51.99 505.93 50.67 505.57 62.21 463.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="62.21"
					y1="463.87"
					x2="63.53"
					y2="464.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="63.53"
					y1="464.24"
					x2="51.99"
					y2="505.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="51.99"
					y1="505.93"
					x2="50.67"
					y2="505.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="50.67"
					y1="505.57"
					x2="62.21"
					y2="463.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="91.49 434.93 92.45 435.91 63.39 464.47 62.43 463.49 91.49 434.93"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="91.49"
					y1="434.93"
					x2="92.45"
					y2="435.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.45"
					y1="435.91"
					x2="63.39"
					y2="464.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="63.39"
					y1="464.47"
					x2="62.43"
					y2="463.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="62.43"
					y1="463.49"
					x2="91.49"
					y2="434.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="131.72 423.85 132.08 425.18 92.22 436.03 91.86 434.71 131.72 423.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="131.72"
					y1="423.85"
					x2="132.08"
					y2="425.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="132.08"
					y1="425.18"
					x2="92.22"
					y2="436.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.22"
					y1="436.03"
					x2="91.86"
					y2="434.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="91.86"
					y1="434.71"
					x2="131.72"
					y2="423.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="90.47 435.47 92.85 434.11 96.94 441.24 94.56 442.6 90.47 435.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="92.85"
					y1="434.11"
					x2="90.47"
					y2="435.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.94"
					y1="441.24"
					x2="92.85"
					y2="434.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.56"
					y1="442.6"
					x2="96.94"
					y2="441.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="90.47"
					y1="435.47"
					x2="94.56"
					y2="442.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="61.6 464.84 62.98 462.48 70.07 466.65 68.68 469.01 61.6 464.84"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="62.98"
					y1="462.48"
					x2="61.6"
					y2="464.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="70.07"
					y1="466.65"
					x2="62.98"
					y2="462.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="68.68"
					y1="469.01"
					x2="70.07"
					y2="466.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="61.6"
					y1="464.84"
					x2="68.68"
					y2="469.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.31"
					y1="661.37"
					x2="504.36"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="502.31"
					y1="650.41"
					x2="504.36"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="502.31"
					y1="650.41"
					x2="502.31"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="458.48"
					y1="661.37"
					x2="456.42"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="458.48"
					y1="650.41"
					x2="456.42"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="458.48"
					y1="650.41"
					x2="458.48"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="502.31"
					y1="661.37"
					x2="502.8"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="506.91"
					y1="650.41"
					x2="502.31"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="459.16 662.05 459.16 661.37 456.42 661.37 456.42 662.05 459.16 662.05"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="501.62 661.37 501.62 662.05 504.36 662.05 504.36 661.37 501.62 661.37"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="459.16 650.41 459.16 649.73 456.42 649.73 456.42 650.41 459.16 650.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="501.62 649.73 501.62 650.41 504.36 650.41 504.36 649.73 501.62 649.73"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="459.16"
					y1="662.05"
					x2="456.42"
					y2="662.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.42"
					y1="662.05"
					x2="456.42"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.42"
					y1="661.37"
					x2="459.16"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.16"
					y1="661.37"
					x2="459.16"
					y2="662.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.62"
					y1="661.37"
					x2="504.36"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.36"
					y1="661.37"
					x2="504.36"
					y2="662.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.36"
					y1="662.05"
					x2="501.62"
					y2="662.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.62"
					y1="662.05"
					x2="501.62"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.16"
					y1="650.41"
					x2="456.42"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.42"
					y1="650.41"
					x2="456.42"
					y2="649.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.42"
					y1="649.73"
					x2="459.16"
					y2="649.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.16"
					y1="649.73"
					x2="459.16"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.62"
					y1="649.73"
					x2="504.36"
					y2="649.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.36"
					y1="649.73"
					x2="504.36"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.36"
					y1="650.41"
					x2="501.62"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.62"
					y1="650.41"
					x2="501.62"
					y2="649.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="459.85 661.37 459.85 650.41 458.82 650.41 458.82 661.37 459.85 661.37"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="501.96 661.37 501.96 650.41 500.93 650.41 500.93 661.37 501.96 661.37"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="471.88 621.36 470.19 623.05 499.24 652.11 500.93 650.41 471.88 621.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="458.82"
					y1="650.41"
					x2="458.48"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.82"
					y1="661.37"
					x2="458.48"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.48"
					y1="650.41"
					x2="458.48"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.96"
					y1="650.41"
					x2="502.31"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.96"
					y1="661.37"
					x2="502.31"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.31"
					y1="650.41"
					x2="502.31"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.85"
					y1="661.37"
					x2="459.85"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.85"
					y1="650.41"
					x2="458.82"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.82"
					y1="650.41"
					x2="458.82"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.82"
					y1="661.37"
					x2="459.85"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.96"
					y1="661.37"
					x2="501.96"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.96"
					y1="650.41"
					x2="500.93"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.93"
					y1="650.41"
					x2="500.93"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.93"
					y1="661.37"
					x2="501.96"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.88"
					y1="621.36"
					x2="470.19"
					y2="623.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470.19"
					y1="623.05"
					x2="499.24"
					y2="652.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.24"
					y1="652.11"
					x2="500.93"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.93"
					y1="650.41"
					x2="471.88"
					y2="621.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.48"
					y1="650.41"
					x2="458.48"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="458.48"
					y1="650.41"
					x2="458.48"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="458.48"
					y1="650.41"
					x2="456.42"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="458.48"
					y1="650.41"
					x2="456.42"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="458.48"
					y1="661.37"
					x2="456.42"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="458.48"
					y1="661.37"
					x2="456.42"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="502.31"
					y1="650.41"
					x2="502.31"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="502.31"
					y1="650.41"
					x2="502.31"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="502.31"
					y1="650.41"
					x2="504.36"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="502.31"
					y1="650.41"
					x2="504.36"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="502.31"
					y1="661.37"
					x2="504.36"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="502.31"
					y1="661.37"
					x2="504.36"
					y2="661.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="502.8"
					y1="661.37"
					x2="502.8"
					y2="684.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="513.76"
					y1="673.78"
					x2="513.76"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="941.15"
					y1="673.78"
					x2="854.63"
					y2="673.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="614.9"
					y1="673.78"
					x2="569.25"
					y2="673.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="566.51"
					y1="673.78"
					x2="560.06"
					y2="673.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="557.32"
					y1="673.78"
					x2="513.76"
					y2="673.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="884.84"
					y1="315.26"
					x2="884.84"
					y2="326.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="659.07"
					y1="421.09"
					x2="659.07"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="58.85"
					y1="506.12"
					x2="47.89"
					y2="506.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="717.82"
					y1="536.54"
					x2="717.82"
					y2="661.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="933.87"
					y1="536.54"
					x2="935.92"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="933.87"
					y1="543.39"
					x2="935.92"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="933.87"
					y1="543.39"
					x2="933.87"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="890.04"
					y1="536.54"
					x2="887.99"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="890.04"
					y1="543.39"
					x2="887.99"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="890.04"
					y1="543.39"
					x2="890.04"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="731.07"
					y1="536.54"
					x2="729.02"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="731.07"
					y1="543.39"
					x2="729.02"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="731.07"
					y1="543.39"
					x2="731.07"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="774.9"
					y1="536.54"
					x2="776.96"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="774.9"
					y1="543.39"
					x2="776.96"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="774.9"
					y1="543.39"
					x2="774.9"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="724.66"
					y1="543.39"
					x2="731.07"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="933.87"
					y1="543.39"
					x2="941.15"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="941.15"
					y1="536.54"
					x2="933.87"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="802.13"
					y1="536.54"
					x2="774.9"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="731.07"
					y1="536.54"
					x2="717.82"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="890.73 535.86 887.99 535.86 887.99 536.54 890.73 536.54 890.73 535.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="933.18 536.54 935.92 536.54 935.92 535.86 933.18 535.86 933.18 536.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="890.73 543.39 887.99 543.39 887.99 544.07 890.73 544.07 890.73 543.39"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="933.18 544.07 935.92 544.07 935.92 543.39 933.18 543.39 933.18 544.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="890.73"
					y1="535.86"
					x2="887.99"
					y2="535.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.99"
					y1="535.86"
					x2="887.99"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.99"
					y1="536.54"
					x2="890.73"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.73"
					y1="536.54"
					x2="890.73"
					y2="535.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.18"
					y1="536.54"
					x2="935.92"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.92"
					y1="536.54"
					x2="935.92"
					y2="535.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.92"
					y1="535.86"
					x2="933.18"
					y2="535.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.18"
					y1="535.86"
					x2="933.18"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.73"
					y1="543.39"
					x2="887.99"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.99"
					y1="543.39"
					x2="887.99"
					y2="544.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.99"
					y1="544.07"
					x2="890.73"
					y2="544.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.73"
					y1="544.07"
					x2="890.73"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.18"
					y1="544.07"
					x2="935.92"
					y2="544.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.92"
					y1="544.07"
					x2="935.92"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="935.92"
					y1="543.39"
					x2="933.18"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.18"
					y1="543.39"
					x2="933.18"
					y2="544.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="891.41 536.54 890.38 536.54 890.38 543.39 891.41 543.39 891.41 536.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="933.53 536.54 932.5 536.54 932.5 543.39 933.53 543.39 933.53 536.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="903.44 572.44 932.5 543.39 930.81 541.69 901.75 570.75 903.44 572.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="890.38"
					y1="543.39"
					x2="890.04"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.38"
					y1="536.54"
					x2="890.04"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.04"
					y1="543.39"
					x2="890.04"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.53"
					y1="543.39"
					x2="933.87"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.53"
					y1="536.54"
					x2="933.87"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.87"
					y1="543.39"
					x2="933.87"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.41"
					y1="536.54"
					x2="891.41"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.41"
					y1="543.39"
					x2="890.38"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.38"
					y1="543.39"
					x2="890.38"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.38"
					y1="536.54"
					x2="891.41"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.53"
					y1="536.54"
					x2="933.53"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="933.53"
					y1="543.39"
					x2="932.5"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="932.5"
					y1="543.39"
					x2="932.5"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="932.5"
					y1="536.54"
					x2="933.53"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.44"
					y1="572.44"
					x2="901.75"
					y2="570.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.75"
					y1="570.75"
					x2="930.81"
					y2="541.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.81"
					y1="541.69"
					x2="932.5"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="932.5"
					y1="543.39"
					x2="903.44"
					y2="572.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.04"
					y1="543.39"
					x2="890.04"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="890.04"
					y1="543.39"
					x2="890.04"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="890.04"
					y1="543.39"
					x2="887.99"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="890.04"
					y1="543.39"
					x2="887.99"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="890.04"
					y1="536.54"
					x2="887.99"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="890.04"
					y1="536.54"
					x2="887.99"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="933.87"
					y1="543.39"
					x2="933.87"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="933.87"
					y1="543.39"
					x2="933.87"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="933.87"
					y1="543.39"
					x2="935.92"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="933.87"
					y1="543.39"
					x2="935.92"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="933.87"
					y1="536.54"
					x2="935.92"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="933.87"
					y1="536.54"
					x2="935.92"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="774.22 535.86 774.22 536.54 776.96 536.54 776.96 535.86 774.22 535.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="731.76 536.54 731.76 535.86 729.02 535.86 729.02 536.54 731.76 536.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="774.22 543.39 774.22 544.07 776.96 544.07 776.96 543.39 774.22 543.39"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="731.76 544.07 731.76 543.39 729.02 543.39 729.02 544.07 731.76 544.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="774.22"
					y1="535.86"
					x2="776.96"
					y2="535.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.96"
					y1="535.86"
					x2="776.96"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.96"
					y1="536.54"
					x2="774.22"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.22"
					y1="536.54"
					x2="774.22"
					y2="535.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.76"
					y1="536.54"
					x2="729.02"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.02"
					y1="536.54"
					x2="729.02"
					y2="535.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.02"
					y1="535.86"
					x2="731.76"
					y2="535.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.76"
					y1="535.86"
					x2="731.76"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.22"
					y1="543.39"
					x2="776.96"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.96"
					y1="543.39"
					x2="776.96"
					y2="544.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.96"
					y1="544.07"
					x2="774.22"
					y2="544.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.22"
					y1="544.07"
					x2="774.22"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.76"
					y1="544.07"
					x2="729.02"
					y2="544.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.02"
					y1="544.07"
					x2="729.02"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.02"
					y1="543.39"
					x2="731.76"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.76"
					y1="543.39"
					x2="731.76"
					y2="544.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="773.53 536.54 773.53 543.39 774.56 543.39 774.56 536.54 773.53 536.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="731.41 536.54 731.41 543.39 732.44 543.39 732.44 536.54 731.41 536.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="761.5 572.44 763.19 570.75 734.14 541.69 732.44 543.39 761.5 572.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="774.56"
					y1="543.39"
					x2="774.9"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.56"
					y1="536.54"
					x2="774.9"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.9"
					y1="543.39"
					x2="774.9"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.41"
					y1="543.39"
					x2="731.07"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.41"
					y1="536.54"
					x2="731.07"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.07"
					y1="543.39"
					x2="731.07"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.53"
					y1="536.54"
					x2="773.53"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.53"
					y1="543.39"
					x2="774.56"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.56"
					y1="543.39"
					x2="774.56"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.56"
					y1="536.54"
					x2="773.53"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.41"
					y1="536.54"
					x2="731.41"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.41"
					y1="543.39"
					x2="732.44"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.44"
					y1="543.39"
					x2="732.44"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.44"
					y1="536.54"
					x2="731.41"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.5"
					y1="572.44"
					x2="763.19"
					y2="570.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.19"
					y1="570.75"
					x2="734.14"
					y2="541.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.14"
					y1="541.69"
					x2="732.44"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.44"
					y1="543.39"
					x2="761.5"
					y2="572.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.9"
					y1="543.39"
					x2="774.9"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="774.9"
					y1="543.39"
					x2="774.9"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="774.9"
					y1="543.39"
					x2="776.96"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="774.9"
					y1="543.39"
					x2="776.96"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="774.9"
					y1="536.54"
					x2="776.96"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="774.9"
					y1="536.54"
					x2="776.96"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="731.07"
					y1="543.39"
					x2="731.07"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="731.07"
					y1="543.39"
					x2="731.07"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="731.07"
					y1="543.39"
					x2="729.02"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="731.07"
					y1="543.39"
					x2="729.02"
					y2="543.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="731.07"
					y1="536.54"
					x2="729.02"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="731.07"
					y1="536.54"
					x2="729.02"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="806.47"
					y1="630.22"
					x2="806.47"
					y2="673.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="824.17"
					y1="543.39"
					x2="824.17"
					y2="630.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="854.63"
					y1="673.78"
					x2="854.63"
					y2="630.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="614.9"
					y1="661.45"
					x2="614.9"
					y2="673.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="717.82"
					y1="661.45"
					x2="614.9"
					y2="661.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="569.25"
					y1="673.78"
					x2="569.25"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="566.51"
					y1="635.47"
					x2="566.51"
					y2="673.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="556.08"
					y1="635.47"
					x2="558.14"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="556.08"
					y1="628.63"
					x2="558.14"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="556.08"
					y1="628.63"
					x2="556.08"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="514.99"
					y1="635.47"
					x2="512.94"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="514.99"
					y1="628.63"
					x2="512.94"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="514.99"
					y1="628.63"
					x2="514.99"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="569.25"
					y1="628.63"
					x2="556.08"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="514.99"
					y1="628.63"
					x2="506.91"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="513.76"
					y1="635.47"
					x2="514.99"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="556.08"
					y1="635.47"
					x2="557.32"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="560.06"
					y1="635.47"
					x2="566.51"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="515.68 636.16 515.68 635.47 512.94 635.47 512.94 636.16 515.68 636.16"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="555.4 635.47 555.4 636.16 558.14 636.16 558.14 635.47 555.4 635.47"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="515.68 628.63 515.68 627.94 512.94 627.94 512.94 628.63 515.68 628.63"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="555.4 627.94 555.4 628.63 558.14 628.63 558.14 627.94 555.4 627.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="515.68"
					y1="636.16"
					x2="512.94"
					y2="636.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.94"
					y1="636.16"
					x2="512.94"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.94"
					y1="635.47"
					x2="515.68"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.68"
					y1="635.47"
					x2="515.68"
					y2="636.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.4"
					y1="635.47"
					x2="558.14"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.14"
					y1="635.47"
					x2="558.14"
					y2="636.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.14"
					y1="636.16"
					x2="555.4"
					y2="636.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.4"
					y1="636.16"
					x2="555.4"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.68"
					y1="628.63"
					x2="512.94"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.94"
					y1="628.63"
					x2="512.94"
					y2="627.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.94"
					y1="627.94"
					x2="515.68"
					y2="627.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.68"
					y1="627.94"
					x2="515.68"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.4"
					y1="627.94"
					x2="558.14"
					y2="627.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.14"
					y1="627.94"
					x2="558.14"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.14"
					y1="628.63"
					x2="555.4"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.4"
					y1="628.63"
					x2="555.4"
					y2="627.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="516.36 635.47 516.36 628.63 515.34 628.63 515.34 635.47 516.36 635.47"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="555.74 635.47 555.74 628.63 554.71 628.63 554.71 635.47 555.74 635.47"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="527.6 601.51 525.9 603.2 553.02 630.32 554.71 628.63 527.6 601.51"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="515.34"
					y1="628.63"
					x2="514.99"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.34"
					y1="635.47"
					x2="514.99"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.99"
					y1="628.63"
					x2="514.99"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.74"
					y1="628.63"
					x2="556.08"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.74"
					y1="635.47"
					x2="556.08"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.08"
					y1="628.63"
					x2="556.08"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.36"
					y1="635.47"
					x2="516.36"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.36"
					y1="628.63"
					x2="515.34"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.34"
					y1="628.63"
					x2="515.34"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.34"
					y1="635.47"
					x2="516.36"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.74"
					y1="635.47"
					x2="555.74"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.74"
					y1="628.63"
					x2="554.71"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.71"
					y1="628.63"
					x2="554.71"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.71"
					y1="635.47"
					x2="555.74"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.6"
					y1="601.51"
					x2="525.9"
					y2="603.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.9"
					y1="603.2"
					x2="553.02"
					y2="630.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.02"
					y1="630.32"
					x2="554.71"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.71"
					y1="628.63"
					x2="527.6"
					y2="601.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.99"
					y1="628.63"
					x2="514.99"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="514.99"
					y1="628.63"
					x2="514.99"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="514.99"
					y1="628.63"
					x2="512.94"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="514.99"
					y1="628.63"
					x2="512.94"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="514.99"
					y1="635.47"
					x2="512.94"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="514.99"
					y1="635.47"
					x2="512.94"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="556.08"
					y1="628.63"
					x2="556.08"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="556.08"
					y1="628.63"
					x2="556.08"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="556.08"
					y1="628.63"
					x2="558.14"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="556.08"
					y1="628.63"
					x2="558.14"
					y2="628.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="556.08"
					y1="635.47"
					x2="558.14"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="556.08"
					y1="635.47"
					x2="558.14"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="506.91"
					y1="628.63"
					x2="506.91"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="513.76"
					y1="650.41"
					x2="513.76"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="560.06"
					y1="673.78"
					x2="560.06"
					y2="635.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="557.32"
					y1="635.47"
					x2="557.32"
					y2="673.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="802.13"
					y1="528.98"
					x2="802.13"
					y2="531.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="808.97"
					y1="528.98"
					x2="808.97"
					y2="531.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="808.97"
					y1="528.98"
					x2="802.13"
					y2="528.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="802.13"
					y1="485.15"
					x2="802.13"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="808.97"
					y1="485.15"
					x2="808.97"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="808.97"
					y1="485.15"
					x2="802.13"
					y2="485.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="808.97"
					y1="536.54"
					x2="808.97"
					y2="528.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="808.97"
					y1="485.15"
					x2="808.97"
					y2="471.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="802.13"
					y1="478.55"
					x2="802.13"
					y2="485.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="802.13"
					y1="528.98"
					x2="802.13"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="801.44 485.83 802.13 485.83 802.13 483.09 801.44 483.09 801.44 485.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="802.13 528.29 801.44 528.29 801.44 531.03 802.13 531.03 802.13 528.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="808.97 485.83 809.66 485.83 809.66 483.09 808.97 483.09 808.97 485.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="809.66 528.29 808.97 528.29 808.97 531.03 809.66 531.03 809.66 528.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="801.44"
					y1="485.83"
					x2="801.44"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="801.44"
					y1="483.09"
					x2="802.13"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.13"
					y1="483.09"
					x2="802.13"
					y2="485.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.13"
					y1="485.83"
					x2="801.44"
					y2="485.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.13"
					y1="528.29"
					x2="802.13"
					y2="531.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.13"
					y1="531.03"
					x2="801.44"
					y2="531.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="801.44"
					y1="531.03"
					x2="801.44"
					y2="528.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="801.44"
					y1="528.29"
					x2="802.13"
					y2="528.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.97"
					y1="485.83"
					x2="808.97"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.97"
					y1="483.09"
					x2="809.66"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="809.66"
					y1="483.09"
					x2="809.66"
					y2="485.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="809.66"
					y1="485.83"
					x2="808.97"
					y2="485.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="809.66"
					y1="528.29"
					x2="809.66"
					y2="531.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="809.66"
					y1="531.03"
					x2="808.97"
					y2="531.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.97"
					y1="531.03"
					x2="808.97"
					y2="528.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.97"
					y1="528.29"
					x2="809.66"
					y2="528.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="802.13 486.52 808.97 486.52 808.97 485.49 802.13 485.49 802.13 486.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="802.13 528.64 808.97 528.64 808.97 527.61 802.13 527.61 802.13 528.64"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="838.03 498.55 836.33 496.86 807.28 525.91 808.97 527.61 838.03 498.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="808.97"
					y1="485.49"
					x2="808.97"
					y2="485.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.13"
					y1="485.49"
					x2="802.13"
					y2="485.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.97"
					y1="485.15"
					x2="802.13"
					y2="485.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.97"
					y1="528.64"
					x2="808.97"
					y2="528.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.13"
					y1="528.64"
					x2="802.13"
					y2="528.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.97"
					y1="528.98"
					x2="802.13"
					y2="528.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.13"
					y1="486.52"
					x2="808.97"
					y2="486.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.97"
					y1="486.52"
					x2="808.97"
					y2="485.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.97"
					y1="485.49"
					x2="802.13"
					y2="485.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.13"
					y1="485.49"
					x2="802.13"
					y2="486.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.13"
					y1="528.64"
					x2="808.97"
					y2="528.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.97"
					y1="528.64"
					x2="808.97"
					y2="527.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.97"
					y1="527.61"
					x2="802.13"
					y2="527.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.13"
					y1="527.61"
					x2="802.13"
					y2="528.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="838.03"
					y1="498.55"
					x2="836.33"
					y2="496.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="836.33"
					y1="496.86"
					x2="807.28"
					y2="525.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.28"
					y1="525.91"
					x2="808.97"
					y2="527.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.97"
					y1="527.61"
					x2="838.03"
					y2="498.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.97"
					y1="485.15"
					x2="802.13"
					y2="485.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="808.97"
					y1="485.15"
					x2="802.13"
					y2="485.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="808.97"
					y1="485.15"
					x2="808.97"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="808.97"
					y1="485.15"
					x2="808.97"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="802.13"
					y1="485.15"
					x2="802.13"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="802.13"
					y1="485.15"
					x2="802.13"
					y2="483.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="808.97"
					y1="528.98"
					x2="802.13"
					y2="528.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="808.97"
					y1="528.98"
					x2="802.13"
					y2="528.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="808.97"
					y1="528.98"
					x2="808.97"
					y2="531.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="808.97"
					y1="528.98"
					x2="808.97"
					y2="531.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="802.13"
					y1="528.98"
					x2="802.13"
					y2="531.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="802.13"
					y1="528.98"
					x2="802.13"
					y2="531.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="752.35"
					y1="361.38"
					x2="752.35"
					y2="359.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="753.72"
					y1="361.38"
					x2="752.35"
					y2="361.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="759.2"
					y1="361.38"
					x2="759.2"
					y2="359.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="759.2"
					y1="361.38"
					x2="753.72"
					y2="361.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="752.35"
					y1="425.37"
					x2="752.35"
					y2="427.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="753.72"
					y1="425.37"
					x2="752.35"
					y2="425.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="759.2"
					y1="425.37"
					x2="759.2"
					y2="427.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="759.2"
					y1="425.37"
					x2="753.72"
					y2="425.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="752.35"
					y1="425.37"
					x2="752.35"
					y2="427.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="753.72 424.35 752.35 424.35 752.35 425.03 753.72 425.03 753.72 424.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="751.67 424.35 751.67 427.08 752.35 427.08 752.35 424.35 751.67 424.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="753.72 361.72 752.35 361.72 752.35 362.4 753.72 362.4 753.72 361.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="752.35 362.4 752.35 359.67 751.67 359.67 751.67 362.4 752.35 362.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="759.2 424.35 759.2 427.08 760.92 427.08 760.92 424.35 759.2 424.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="760.92 362.4 760.92 359.67 759.2 359.67 759.2 362.4 760.92 362.4"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="753.72"
					y1="424.35"
					x2="752.35"
					y2="424.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.35"
					y1="424.35"
					x2="752.35"
					y2="425.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.35"
					y1="425.03"
					x2="753.72"
					y2="425.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.72"
					y1="425.03"
					x2="753.72"
					y2="424.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.67"
					y1="424.35"
					x2="751.67"
					y2="427.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.67"
					y1="427.08"
					x2="752.35"
					y2="427.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.35"
					y1="427.08"
					x2="752.35"
					y2="424.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.35"
					y1="424.35"
					x2="751.67"
					y2="424.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.72"
					y1="361.72"
					x2="752.35"
					y2="361.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.35"
					y1="361.72"
					x2="752.35"
					y2="362.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.35"
					y1="362.4"
					x2="753.72"
					y2="362.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.72"
					y1="362.4"
					x2="753.72"
					y2="361.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.35"
					y1="362.4"
					x2="752.35"
					y2="359.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.35"
					y1="359.67"
					x2="751.67"
					y2="359.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.67"
					y1="359.67"
					x2="751.67"
					y2="362.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.67"
					y1="362.4"
					x2="752.35"
					y2="362.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.2"
					y1="424.35"
					x2="759.2"
					y2="427.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.2"
					y1="427.08"
					x2="760.92"
					y2="427.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.92"
					y1="427.08"
					x2="760.92"
					y2="424.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.92"
					y1="424.35"
					x2="759.2"
					y2="424.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.92"
					y1="362.4"
					x2="760.92"
					y2="359.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.92"
					y1="359.67"
					x2="759.2"
					y2="359.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.2"
					y1="359.67"
					x2="759.2"
					y2="362.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.2"
					y1="362.4"
					x2="760.92"
					y2="362.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="753.72 422.29 753.72 425.03 759.2 425.03 759.2 422.29 753.72 422.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="753.72 361.72 753.72 364.46 759.2 364.46 759.2 361.72 753.72 361.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="759.2 394.75 759.2 364.46 756.81 364.46 756.81 394.75 759.2 394.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="756.81 405.85 756.81 375.57 754.41 375.57 754.41 405.85 756.81 405.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="759.2"
					y1="425.03"
					x2="759.2"
					y2="425.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.72"
					y1="425.03"
					x2="753.72"
					y2="425.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.2"
					y1="425.37"
					x2="753.72"
					y2="425.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.2"
					y1="361.72"
					x2="759.2"
					y2="361.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.72"
					y1="361.72"
					x2="753.72"
					y2="361.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.2"
					y1="361.38"
					x2="753.72"
					y2="361.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.72"
					y1="422.29"
					x2="759.2"
					y2="422.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.2"
					y1="422.29"
					x2="759.2"
					y2="425.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.2"
					y1="425.03"
					x2="753.72"
					y2="425.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.72"
					y1="425.03"
					x2="753.72"
					y2="422.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.72"
					y1="361.72"
					x2="759.2"
					y2="361.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.2"
					y1="361.72"
					x2="759.2"
					y2="364.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.2"
					y1="364.46"
					x2="753.72"
					y2="364.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.72"
					y1="364.46"
					x2="753.72"
					y2="361.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.2"
					y1="394.75"
					x2="756.81"
					y2="394.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.81"
					y1="394.75"
					x2="756.81"
					y2="364.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.81"
					y1="364.46"
					x2="759.2"
					y2="364.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.2"
					y1="364.46"
					x2="759.2"
					y2="394.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.81"
					y1="405.85"
					x2="754.41"
					y2="405.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.41"
					y1="405.85"
					x2="754.41"
					y2="375.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.41"
					y1="375.57"
					x2="756.81"
					y2="375.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.81"
					y1="375.57"
					x2="756.81"
					y2="405.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.2"
					y1="425.37"
					x2="753.72"
					y2="425.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="759.2"
					y1="425.37"
					x2="753.72"
					y2="425.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="753.72"
					y1="425.37"
					x2="752.35"
					y2="425.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="759.2"
					y1="425.37"
					x2="759.2"
					y2="427.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="753.72"
					y1="425.37"
					x2="752.35"
					y2="425.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="752.35"
					y1="425.37"
					x2="752.35"
					y2="427.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="752.35"
					y1="425.37"
					x2="752.35"
					y2="427.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="759.2"
					y1="361.38"
					x2="753.72"
					y2="361.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="759.2"
					y1="361.38"
					x2="753.72"
					y2="361.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="753.72"
					y1="361.38"
					x2="752.35"
					y2="361.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="759.2"
					y1="361.38"
					x2="759.2"
					y2="359.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="753.72"
					y1="361.38"
					x2="752.35"
					y2="361.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="752.35"
					y1="361.38"
					x2="752.35"
					y2="359.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="752.35"
					y1="361.38"
					x2="752.35"
					y2="359.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="373.5"
					y1="643.87"
					x2="373.5"
					y2="645.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="366.65"
					y1="643.87"
					x2="366.65"
					y2="645.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="366.65"
					y1="643.87"
					x2="373.5"
					y2="643.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="373.5"
					y1="600.04"
					x2="373.5"
					y2="597.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="366.65"
					y1="600.04"
					x2="366.65"
					y2="597.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="366.65"
					y1="600.04"
					x2="373.5"
					y2="600.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="373.5"
					y1="650.41"
					x2="373.5"
					y2="643.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="366.65"
					y1="643.87"
					x2="366.65"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="374.18 600.72 374.18 597.98 373.5 597.98 373.5 600.72 374.18 600.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="373.5 643.18 373.5 645.92 374.18 645.92 374.18 643.18 373.5 643.18"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="366.65 600.72 366.65 597.98 365.96 597.98 365.96 600.72 366.65 600.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="365.96 643.18 365.96 645.92 366.65 645.92 366.65 643.18 365.96 643.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="374.18"
					y1="600.72"
					x2="374.18"
					y2="597.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.18"
					y1="597.98"
					x2="373.5"
					y2="597.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.5"
					y1="597.98"
					x2="373.5"
					y2="600.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.5"
					y1="600.72"
					x2="374.18"
					y2="600.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.5"
					y1="643.18"
					x2="373.5"
					y2="645.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.5"
					y1="645.92"
					x2="374.18"
					y2="645.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.18"
					y1="645.92"
					x2="374.18"
					y2="643.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.18"
					y1="643.18"
					x2="373.5"
					y2="643.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="600.72"
					x2="366.65"
					y2="597.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="597.98"
					x2="365.96"
					y2="597.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.96"
					y1="597.98"
					x2="365.96"
					y2="600.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.96"
					y1="600.72"
					x2="366.65"
					y2="600.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.96"
					y1="643.18"
					x2="365.96"
					y2="645.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.96"
					y1="645.92"
					x2="366.65"
					y2="645.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="645.92"
					x2="366.65"
					y2="643.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="643.18"
					x2="365.96"
					y2="643.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="373.5 601.4 373.5 600.38 366.65 600.38 366.65 601.4 373.5 601.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="373.5 643.52 373.5 642.5 366.65 642.5 366.65 643.52 373.5 643.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="337.59 613.44 366.65 642.5 368.34 640.8 339.29 611.75 337.59 613.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="366.65"
					y1="600.38"
					x2="366.65"
					y2="600.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.5"
					y1="600.38"
					x2="373.5"
					y2="600.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="600.04"
					x2="373.5"
					y2="600.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="643.52"
					x2="366.65"
					y2="643.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.5"
					y1="643.52"
					x2="373.5"
					y2="643.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="643.87"
					x2="373.5"
					y2="643.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.5"
					y1="601.4"
					x2="366.65"
					y2="601.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="601.4"
					x2="366.65"
					y2="600.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="600.38"
					x2="373.5"
					y2="600.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.5"
					y1="600.38"
					x2="373.5"
					y2="601.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.5"
					y1="643.52"
					x2="366.65"
					y2="643.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="643.52"
					x2="366.65"
					y2="642.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="642.5"
					x2="373.5"
					y2="642.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.5"
					y1="642.5"
					x2="373.5"
					y2="643.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.59"
					y1="613.44"
					x2="339.29"
					y2="611.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.29"
					y1="611.75"
					x2="368.34"
					y2="640.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.34"
					y1="640.8"
					x2="366.65"
					y2="642.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="642.5"
					x2="337.59"
					y2="613.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.65"
					y1="600.04"
					x2="373.5"
					y2="600.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="366.65"
					y1="600.04"
					x2="373.5"
					y2="600.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="366.65"
					y1="600.04"
					x2="366.65"
					y2="597.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="366.65"
					y1="600.04"
					x2="366.65"
					y2="597.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="373.5"
					y1="600.04"
					x2="373.5"
					y2="597.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="373.5"
					y1="600.04"
					x2="373.5"
					y2="597.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="366.65"
					y1="643.87"
					x2="373.5"
					y2="643.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="366.65"
					y1="643.87"
					x2="373.5"
					y2="643.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="366.65"
					y1="643.87"
					x2="366.65"
					y2="645.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="366.65"
					y1="643.87"
					x2="366.65"
					y2="645.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="373.5"
					y1="643.87"
					x2="373.5"
					y2="645.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="373.5"
					y1="643.87"
					x2="373.5"
					y2="645.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="366.65"
					y1="560.11"
					x2="332.29"
					y2="560.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="332.29"
					y1="549.7"
					x2="332.29"
					y2="551.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="330.92"
					y1="549.7"
					x2="332.29"
					y2="549.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="325.44"
					y1="549.7"
					x2="325.44"
					y2="551.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="325.44"
					y1="549.7"
					x2="330.92"
					y2="549.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="332.29"
					y1="485.5"
					x2="332.29"
					y2="483.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="330.92"
					y1="485.5"
					x2="332.29"
					y2="485.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="325.44"
					y1="485.5"
					x2="325.44"
					y2="483.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="325.44"
					y1="485.5"
					x2="330.92"
					y2="485.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="332.29"
					y1="560.11"
					x2="332.29"
					y2="549.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="330.92 486.53 332.29 486.53 332.29 485.85 330.92 485.85 330.92 486.53"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="332.98 486.53 332.98 483.79 332.29 483.79 332.29 486.53 332.98 486.53"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="330.92 549.35 332.29 549.35 332.29 548.67 330.92 548.67 330.92 549.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="332.29 548.67 332.29 551.41 332.98 551.41 332.98 548.67 332.29 548.67"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="325.44 486.53 325.44 483.79 323.73 483.79 323.73 486.53 325.44 486.53"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="323.73 548.67 323.73 551.41 325.44 551.41 325.44 548.67 323.73 548.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="330.92"
					y1="486.53"
					x2="332.29"
					y2="486.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.29"
					y1="486.53"
					x2="332.29"
					y2="485.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.29"
					y1="485.85"
					x2="330.92"
					y2="485.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.92"
					y1="485.85"
					x2="330.92"
					y2="486.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.98"
					y1="486.53"
					x2="332.98"
					y2="483.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.98"
					y1="483.79"
					x2="332.29"
					y2="483.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.29"
					y1="483.79"
					x2="332.29"
					y2="486.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.29"
					y1="486.53"
					x2="332.98"
					y2="486.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.92"
					y1="549.35"
					x2="332.29"
					y2="549.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.29"
					y1="549.35"
					x2="332.29"
					y2="548.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.29"
					y1="548.67"
					x2="330.92"
					y2="548.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.92"
					y1="548.67"
					x2="330.92"
					y2="549.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.29"
					y1="548.67"
					x2="332.29"
					y2="551.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.29"
					y1="551.41"
					x2="332.98"
					y2="551.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.98"
					y1="551.41"
					x2="332.98"
					y2="548.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.98"
					y1="548.67"
					x2="332.29"
					y2="548.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.44"
					y1="486.53"
					x2="325.44"
					y2="483.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.44"
					y1="483.79"
					x2="323.73"
					y2="483.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.73"
					y1="483.79"
					x2="323.73"
					y2="486.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.73"
					y1="486.53"
					x2="325.44"
					y2="486.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.73"
					y1="548.67"
					x2="323.73"
					y2="551.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.73"
					y1="551.41"
					x2="325.44"
					y2="551.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.44"
					y1="551.41"
					x2="325.44"
					y2="548.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.44"
					y1="548.67"
					x2="323.73"
					y2="548.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="330.92 488.59 330.92 485.85 325.44 485.85 325.44 488.59 330.92 488.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="330.92 549.35 330.92 546.62 325.44 546.62 325.44 549.35 330.92 549.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="325.44 516.23 325.44 546.62 327.84 546.62 327.84 516.23 325.44 516.23"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="327.84 505.02 327.84 535.41 330.24 535.41 330.24 505.02 327.84 505.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="325.44"
					y1="485.85"
					x2="325.44"
					y2="485.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.92"
					y1="485.85"
					x2="330.92"
					y2="485.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.44"
					y1="485.5"
					x2="330.92"
					y2="485.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.44"
					y1="549.35"
					x2="325.44"
					y2="549.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.92"
					y1="549.35"
					x2="330.92"
					y2="549.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.44"
					y1="549.7"
					x2="330.92"
					y2="549.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.92"
					y1="488.59"
					x2="325.44"
					y2="488.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.44"
					y1="488.59"
					x2="325.44"
					y2="485.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.44"
					y1="485.85"
					x2="330.92"
					y2="485.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.92"
					y1="485.85"
					x2="330.92"
					y2="488.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.92"
					y1="549.35"
					x2="325.44"
					y2="549.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.44"
					y1="549.35"
					x2="325.44"
					y2="546.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.44"
					y1="546.62"
					x2="330.92"
					y2="546.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.92"
					y1="546.62"
					x2="330.92"
					y2="549.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.44"
					y1="516.23"
					x2="327.84"
					y2="516.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.84"
					y1="516.23"
					x2="327.84"
					y2="546.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.84"
					y1="546.62"
					x2="325.44"
					y2="546.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.44"
					y1="546.62"
					x2="325.44"
					y2="516.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.84"
					y1="505.02"
					x2="330.24"
					y2="505.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.24"
					y1="505.02"
					x2="330.24"
					y2="535.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.24"
					y1="535.41"
					x2="327.84"
					y2="535.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.84"
					y1="535.41"
					x2="327.84"
					y2="505.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.44"
					y1="485.5"
					x2="330.92"
					y2="485.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="325.44"
					y1="485.5"
					x2="330.92"
					y2="485.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="330.92"
					y1="485.5"
					x2="332.29"
					y2="485.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="325.44"
					y1="485.5"
					x2="325.44"
					y2="483.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="330.92"
					y1="485.5"
					x2="332.29"
					y2="485.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="332.29"
					y1="485.5"
					x2="332.29"
					y2="483.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="332.29"
					y1="485.5"
					x2="332.29"
					y2="483.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="325.44"
					y1="549.7"
					x2="330.92"
					y2="549.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="325.44"
					y1="549.7"
					x2="330.92"
					y2="549.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="330.92"
					y1="549.7"
					x2="332.29"
					y2="549.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="325.44"
					y1="549.7"
					x2="325.44"
					y2="551.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="330.92"
					y1="549.7"
					x2="332.29"
					y2="549.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="332.29"
					y1="549.7"
					x2="332.29"
					y2="551.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="332.29"
					y1="549.7"
					x2="332.29"
					y2="551.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="131.96"
					y1="421.09"
					x2="131.96"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="209.23"
					y1="432.05"
					x2="209.23"
					y2="421.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="300.94"
					y1="421.09"
					x2="300.94"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="403.33"
					y1="432.05"
					x2="403.33"
					y2="421.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="510.43"
					y1="421.09"
					x2="510.43"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="576.23"
					y1="432.05"
					x2="576.23"
					y2="421.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="777.74"
					y1="326.22"
					x2="777.74"
					y2="315.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="73.53 408.56 70.79 408.56 70.79 381 73.53 381 73.53 408.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="73.53"
					y1="408.56"
					x2="73.53"
					y2="381"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".12"
				/>
				<line
					x1="70.79"
					y1="381"
					x2="70.79"
					y2="408.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".12"
				/>
				<line
					x1="70.79"
					y1="408.56"
					x2="73.53"
					y2="408.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".12"
				/>
				<polyline
					points="136.53 318 136.53 315.26 188.31 315.26 188.31 318 136.53 318"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="136.53"
					y1="318"
					x2="188.31"
					y2="318"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".12"
				/>
				<line
					x1="188.31"
					y1="318"
					x2="188.31"
					y2="315.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".12"
				/>
				<line
					x1="188.31"
					y1="315.26"
					x2="136.53"
					y2="315.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".12"
				/>
				<polyline
					points="136.53 315.26 136.53 318 128.94 318.46 121.45 319.83 114.19 322.09 107.25 325.21 100.74 329.15 94.75 333.84 89.37 339.22 84.68 345.21 80.74 351.72 77.62 358.66 75.36 365.92 73.99 373.41 73.53 381 70.79 381 71.27 373.08 72.7 365.27 75.06 357.69 78.32 350.45 82.43 343.66 87.32 337.41 92.94 331.79 99.18 326.9 105.98 322.79 113.22 319.53 120.8 317.17 128.61 315.74 136.53 315.26"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m70.79,381c0-36.31,29.43-65.74,65.74-65.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".12"
				/>
				<path
					d="m73.53,381c0-34.8,28.21-63,63.01-63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".12"
				/>
				<line
					x1="796.79"
					y1="595.19"
					x2="796.79"
					y2="630.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.17"
					y1="595.19"
					x2="824.17"
					y2="630.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="796.79"
					y1="595.19"
					x2="824.17"
					y2="595.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.09"
					y1="595.19"
					x2="823.09"
					y2="630.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.29"
					y1="599.01"
					x2="803.29"
					y2="626.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.29"
					y1="626.4"
					x2="819.73"
					y2="626.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.73"
					y1="626.4"
					x2="819.73"
					y2="599.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.73"
					y1="599.01"
					x2="803.29"
					y2="599.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.21"
					y1="597.93"
					x2="802.21"
					y2="627.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.21"
					y1="627.48"
					x2="820.81"
					y2="627.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.81"
					y1="627.48"
					x2="820.81"
					y2="597.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.81"
					y1="597.93"
					x2="802.21"
					y2="597.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m817.63,612.7c0-.89-.72-1.62-1.62-1.62s-1.62.72-1.62,1.62.72,1.62,1.62,1.62,1.62-.73,1.62-1.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="822.69 611.36 820.43 611.57 819.92 611.75 817.06 612.11 816.69 612.31 816.54 612.7 816.69 613.1 817.06 613.3 819.92 613.66 820.43 613.84 822.69 614.05 823.65 613.66 824.04 612.7 823.65 611.75 822.69 611.36"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m822.69,611.36c.75,0,1.35.6,1.35,1.35s-.6,1.35-1.35,1.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.43"
					y1="613.84"
					x2="822.69"
					y2="614.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m820.43,613.84c-.18-.02-.36-.08-.51-.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.06"
					y1="613.3"
					x2="819.92"
					y2="613.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m817.06,613.3c-.3-.04-.53-.3-.53-.6s.23-.56.53-.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.92"
					y1="611.75"
					x2="817.06"
					y2="612.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m819.92,611.75c.15-.1.33-.16.51-.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="822.69"
					y1="611.36"
					x2="820.43"
					y2="611.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="821.35"
					y1="613.44"
					x2="820.55"
					y2="613.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.55"
					y1="611.97"
					x2="821.35"
					y2="611.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="821.35"
					y1="611.97"
					x2="821.35"
					y2="613.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m820.55,613.44c-.4,0-.73-.33-.73-.73s.33-.73.73-.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m819.92,613.66c-.33-.21-.52-.57-.52-.96s.2-.75.52-.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="788.2 577.14 789.59 578.75 791.32 579.97 795.4 581.52 798.8 582.07 802.23 581.86 805.54 580.9 809.98 581.27 814.04 583.13 816.73 584.57 818.44 584.86 818.77 584.86 821.47 583.97 823.43 581.91 824.17 579.16 824.17 564.93 823.74 562.8 822.62 560.95 823.83 560.95 823.83 559.84 821.17 559.84 820.17 559.44 817.64 559.32 815.26 560.18 814.1 560.92 810 562.79 805.5 563.17 802.21 562.22 798.79 562.02 795.4 562.56 791.32 564.12 789.59 565.34 788.2 566.95 787.11 569.39 786.73 572.04 787.11 574.69 788.2 577.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="811.53"
					y1="566.97"
					x2="811.53"
					y2="577.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.17"
					y1="579.16"
					x2="824.17"
					y2="572.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.66"
					y1="579.16"
					x2="823.66"
					y2="572.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.17"
					y1="564.93"
					x2="824.17"
					y2="572.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.66"
					y1="564.93"
					x2="823.66"
					y2="572.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.53"
					y1="576.85"
					x2="813.42"
					y2="576.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.42"
					y1="576.85"
					x2="813.42"
					y2="575.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.42"
					y1="575.28"
					x2="811.53"
					y2="575.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.53"
					y1="567.23"
					x2="813.42"
					y2="567.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.42"
					y1="567.23"
					x2="813.42"
					y2="568.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.42"
					y1="568.8"
					x2="811.53"
					y2="568.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.12"
					y1="560.95"
					x2="823.83"
					y2="560.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.12"
					y1="559.84"
					x2="823.83"
					y2="559.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.83"
					y1="559.84"
					x2="823.83"
					y2="560.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.12"
					y1="559.84"
					x2="819.12"
					y2="560.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.73"
					y1="572.04"
					x2="786.93"
					y2="573.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.93"
					y1="573.74"
					x2="787.37"
					y2="575.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.37"
					y1="575.39"
					x2="788.2"
					y2="577.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.2"
					y1="577.14"
					x2="789.59"
					y2="578.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.59"
					y1="578.75"
					x2="791.32"
					y2="579.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.32"
					y1="579.97"
					x2="793.3"
					y2="580.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.3"
					y1="580.87"
					x2="795.4"
					y2="581.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.4"
					y1="581.52"
					x2="798.79"
					y2="582.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.79"
					y1="582.11"
					x2="802.21"
					y2="581.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.21"
					y1="581.95"
					x2="804.85"
					y2="581.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="804.85"
					y1="581.18"
					x2="807.41"
					y2="579.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.41"
					y1="579.98"
					x2="809.7"
					y2="578.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="809.7"
					y1="578.56"
					x2="811.53"
					y2="577.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="805.54"
					y1="580.9"
					x2="807.91"
					y2="580.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.91"
					y1="580.91"
					x2="810.22"
					y2="581.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.22"
					y1="581.3"
					x2="812.7"
					y2="582.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.7"
					y1="582.29"
					x2="816.35"
					y2="584.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="816.35"
					y1="584.44"
					x2="818.16"
					y2="584.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.16"
					y1="584.85"
					x2="819.97"
					y2="584.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.97"
					y1="584.69"
					x2="821.61"
					y2="583.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="821.61"
					y1="583.99"
					x2="822.93"
					y2="582.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="822.93"
					y1="582.74"
					x2="823.98"
					y2="580.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.98"
					y1="580.37"
					x2="824.17"
					y2="579.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.66"
					y1="579.16"
					x2="823.26"
					y2="580.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.26"
					y1="580.82"
					x2="822.43"
					y2="581.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="822.43"
					y1="581.81"
					x2="821.27"
					y2="582.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="821.27"
					y1="582.43"
					x2="818.17"
					y2="582.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.17"
					y1="582.79"
					x2="817.39"
					y2="582.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.39"
					y1="582.78"
					x2="816.76"
					y2="582.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="816.76"
					y1="582.45"
					x2="816.58"
					y2="582.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="816.58"
					y1="582.06"
					x2="815.36"
					y2="577.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="815.36"
					y1="577.76"
					x2="814.84"
					y2="573.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="814.84"
					y1="573.46"
					x2="814.84"
					y2="572.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="805.5"
					y1="563.17"
					x2="807.88"
					y2="563.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.88"
					y1="563.15"
					x2="810.21"
					y2="562.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.21"
					y1="562.76"
					x2="812.7"
					y2="561.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.7"
					y1="561.8"
					x2="816.35"
					y2="559.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="816.35"
					y1="559.64"
					x2="818.8"
					y2="559.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.8"
					y1="559.23"
					x2="820.03"
					y2="559.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.03"
					y1="559.41"
					x2="821.17"
					y2="559.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.66"
					y1="564.93"
					x2="823.26"
					y2="563.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.26"
					y1="563.27"
					x2="822.43"
					y2="562.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="822.43"
					y1="562.28"
					x2="821.27"
					y2="561.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="821.27"
					y1="561.66"
					x2="818.17"
					y2="561.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.17"
					y1="561.29"
					x2="817.39"
					y2="561.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.39"
					y1="561.31"
					x2="816.76"
					y2="561.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="816.76"
					y1="561.64"
					x2="816.58"
					y2="562.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="816.58"
					y1="562.02"
					x2="815.36"
					y2="566.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="815.36"
					y1="566.33"
					x2="814.84"
					y2="570.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="814.84"
					y1="570.63"
					x2="814.84"
					y2="572.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.73"
					y1="572.04"
					x2="786.93"
					y2="570.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.93"
					y1="570.34"
					x2="787.37"
					y2="568.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.37"
					y1="568.7"
					x2="788.2"
					y2="566.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.2"
					y1="566.95"
					x2="789.59"
					y2="565.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.59"
					y1="565.33"
					x2="791.32"
					y2="564.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.32"
					y1="564.12"
					x2="793.3"
					y2="563.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.3"
					y1="563.22"
					x2="795.4"
					y2="562.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.4"
					y1="562.56"
					x2="798.79"
					y2="561.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.79"
					y1="561.97"
					x2="802.21"
					y2="562.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.21"
					y1="562.13"
					x2="804.85"
					y2="562.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="804.85"
					y1="562.9"
					x2="807.41"
					y2="564.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.41"
					y1="564.1"
					x2="809.7"
					y2="565.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="809.7"
					y1="565.53"
					x2="811.53"
					y2="566.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="815.37"
					y1="583.97"
					x2="814.4"
					y2="582.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="814.4"
					y1="582.91"
					x2="814.26"
					y2="582.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="814.26"
					y1="582.23"
					x2="813.72"
					y2="573.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.72"
					y1="573.48"
					x2="813.72"
					y2="572.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="815.37"
					y1="560.12"
					x2="814.4"
					y2="561.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="814.4"
					y1="561.17"
					x2="814.26"
					y2="561.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="814.26"
					y1="561.86"
					x2="813.72"
					y2="570.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.72"
					y1="570.61"
					x2="813.72"
					y2="572.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="822.62"
					y1="560.95"
					x2="822.93"
					y2="561.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="822.93"
					y1="561.34"
					x2="823.98"
					y2="563.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.98"
					y1="563.71"
					x2="824.17"
					y2="564.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="824.17 588.48 823.63 588.48 823.63 585.74 824.17 585.74 824.17 588.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="824.17"
					y1="588.48"
					x2="823.63"
					y2="588.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.63"
					y1="588.48"
					x2="823.63"
					y2="585.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.63"
					y1="585.74"
					x2="824.17"
					y2="585.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.17"
					y1="585.74"
					x2="824.17"
					y2="588.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="824.17 555.6 824.17 558.35 823.63 558.35 823.63 555.6 824.17 555.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="824.17"
					y1="555.6"
					x2="824.17"
					y2="558.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.17"
					y1="558.35"
					x2="823.63"
					y2="558.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.63"
					y1="558.35"
					x2="823.63"
					y2="555.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.63"
					y1="555.6"
					x2="824.17"
					y2="555.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="823.63 587.38 819.17 587.38 819.17 586.83 823.63 586.83 823.63 587.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="823.63"
					y1="587.38"
					x2="819.17"
					y2="587.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.17"
					y1="587.38"
					x2="819.17"
					y2="586.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.17"
					y1="586.83"
					x2="823.63"
					y2="586.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.63"
					y1="586.83"
					x2="823.63"
					y2="587.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="823.63 556.7 823.63 557.25 819.17 557.25 819.17 556.7 823.63 556.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="823.63"
					y1="556.7"
					x2="823.63"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.63"
					y1="557.25"
					x2="819.17"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.17"
					y1="557.25"
					x2="819.17"
					y2="556.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.17"
					y1="556.7"
					x2="823.63"
					y2="556.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="820.54 586.83 819.44 586.83 819.44 557.25 820.54 557.25 820.54 586.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="820.54"
					y1="586.83"
					x2="819.44"
					y2="586.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.44"
					y1="586.83"
					x2="819.44"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.44"
					y1="557.25"
					x2="820.54"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.54"
					y1="557.25"
					x2="820.54"
					y2="586.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.34"
					y1="595.19"
					x2="868.34"
					y2="630.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.34"
					y1="595.19"
					x2="840.96"
					y2="595.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.84"
					y1="599.01"
					x2="861.84"
					y2="626.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.84"
					y1="626.4"
					x2="845.41"
					y2="626.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="845.41"
					y1="626.4"
					x2="845.41"
					y2="599.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="845.41"
					y1="599.01"
					x2="861.84"
					y2="599.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="862.92"
					y1="597.93"
					x2="862.92"
					y2="627.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="862.92"
					y1="627.48"
					x2="844.33"
					y2="627.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.33"
					y1="627.48"
					x2="844.33"
					y2="597.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.33"
					y1="597.93"
					x2="862.92"
					y2="597.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m850.74,612.7c0-.89-.72-1.62-1.62-1.62s-1.62.72-1.62,1.62.73,1.62,1.62,1.62,1.62-.73,1.62-1.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="842.44 611.36 844.7 611.57 845.22 611.75 848.07 612.11 848.45 612.31 848.6 612.7 848.45 613.1 848.07 613.3 845.22 613.66 844.7 613.84 842.44 614.05 841.49 613.66 841.1 612.7 841.49 611.75 842.44 611.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="842.44"
					y1="611.36"
					x2="844.7"
					y2="611.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m844.7,611.57c.18.02.36.08.51.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="845.22"
					y1="611.75"
					x2="848.07"
					y2="612.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m848.07,612.11c.3.04.53.29.53.6s-.22.56-.53.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.07"
					y1="613.3"
					x2="845.22"
					y2="613.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m845.22,613.66c-.15.1-.33.16-.51.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.7"
					y1="613.84"
					x2="842.44"
					y2="614.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m842.44,614.05c-.74,0-1.35-.6-1.35-1.35s.6-1.35,1.35-1.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="843.79"
					y1="613.44"
					x2="844.59"
					y2="613.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.59"
					y1="611.97"
					x2="843.79"
					y2="611.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="843.79"
					y1="611.97"
					x2="843.79"
					y2="613.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m844.59,611.97c.41,0,.73.33.73.73s-.33.73-.73.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m845.22,611.75c.32.21.52.57.52.95s-.2.75-.52.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="876.93 577.14 878.02 574.69 878.4 572.04 878.02 569.39 876.93 566.95 875.55 565.34 873.81 564.12 869.74 562.56 866.35 562.02 862.93 562.22 859.63 563.17 855.14 562.79 851.03 560.92 849.88 560.18 847.5 559.32 844.97 559.44 843.97 559.84 841.31 559.84 841.31 560.95 842.52 560.95 841.4 562.8 840.96 564.93 840.96 579.16 841.71 581.91 843.66 583.97 846.37 584.86 846.7 584.86 848.41 584.57 851.1 583.13 855.15 581.27 859.6 580.9 862.9 581.86 866.34 582.07 869.74 581.52 873.81 579.97 875.55 578.75 876.93 577.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="853.61"
					y1="566.97"
					x2="853.61"
					y2="577.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="840.96"
					y1="579.16"
					x2="840.96"
					y2="572.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.47"
					y1="579.16"
					x2="841.47"
					y2="572.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="840.96"
					y1="564.93"
					x2="840.96"
					y2="572.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.47"
					y1="564.93"
					x2="841.47"
					y2="572.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="853.61"
					y1="576.85"
					x2="851.72"
					y2="576.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="851.72"
					y1="576.85"
					x2="851.72"
					y2="575.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="851.72"
					y1="575.28"
					x2="853.61"
					y2="575.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="853.61"
					y1="567.23"
					x2="851.72"
					y2="567.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="851.72"
					y1="567.23"
					x2="851.72"
					y2="568.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="851.72"
					y1="568.8"
					x2="853.61"
					y2="568.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.02"
					y1="560.95"
					x2="841.31"
					y2="560.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.02"
					y1="559.84"
					x2="841.31"
					y2="559.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.31"
					y1="559.84"
					x2="841.31"
					y2="560.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.02"
					y1="559.84"
					x2="846.02"
					y2="560.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="878.4"
					y1="572.04"
					x2="878.21"
					y2="573.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="878.21"
					y1="573.74"
					x2="877.77"
					y2="575.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.77"
					y1="575.39"
					x2="876.93"
					y2="577.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.93"
					y1="577.14"
					x2="875.55"
					y2="578.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.55"
					y1="578.75"
					x2="873.81"
					y2="579.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.81"
					y1="579.97"
					x2="871.84"
					y2="580.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.84"
					y1="580.87"
					x2="869.74"
					y2="581.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="869.74"
					y1="581.52"
					x2="866.34"
					y2="582.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.34"
					y1="582.11"
					x2="862.93"
					y2="581.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="862.93"
					y1="581.95"
					x2="860.28"
					y2="581.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="860.28"
					y1="581.18"
					x2="857.73"
					y2="579.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.73"
					y1="579.98"
					x2="855.44"
					y2="578.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.44"
					y1="578.56"
					x2="853.61"
					y2="577.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.6"
					y1="580.9"
					x2="857.22"
					y2="580.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.22"
					y1="580.91"
					x2="854.91"
					y2="581.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.91"
					y1="581.3"
					x2="852.44"
					y2="582.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="852.44"
					y1="582.29"
					x2="848.79"
					y2="584.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.79"
					y1="584.44"
					x2="846.97"
					y2="584.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.97"
					y1="584.85"
					x2="845.17"
					y2="584.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="845.17"
					y1="584.69"
					x2="843.52"
					y2="583.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="843.52"
					y1="583.99"
					x2="842.2"
					y2="582.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="842.2"
					y1="582.74"
					x2="841.16"
					y2="580.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.16"
					y1="580.37"
					x2="840.96"
					y2="579.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.47"
					y1="579.16"
					x2="841.87"
					y2="580.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.87"
					y1="580.82"
					x2="842.71"
					y2="581.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="842.71"
					y1="581.81"
					x2="843.87"
					y2="582.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="843.87"
					y1="582.43"
					x2="846.97"
					y2="582.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.97"
					y1="582.79"
					x2="847.75"
					y2="582.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="847.75"
					y1="582.78"
					x2="848.37"
					y2="582.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.37"
					y1="582.45"
					x2="848.55"
					y2="582.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.55"
					y1="582.06"
					x2="849.78"
					y2="577.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.78"
					y1="577.76"
					x2="850.3"
					y2="573.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="850.3"
					y1="573.46"
					x2="850.3"
					y2="572.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.63"
					y1="563.17"
					x2="857.25"
					y2="563.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.25"
					y1="563.15"
					x2="854.93"
					y2="562.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.93"
					y1="562.76"
					x2="852.44"
					y2="561.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="852.44"
					y1="561.8"
					x2="848.79"
					y2="559.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.79"
					y1="559.64"
					x2="846.33"
					y2="559.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.33"
					y1="559.23"
					x2="845.11"
					y2="559.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="845.11"
					y1="559.41"
					x2="843.97"
					y2="559.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.47"
					y1="564.93"
					x2="841.87"
					y2="563.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.87"
					y1="563.27"
					x2="842.71"
					y2="562.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="842.71"
					y1="562.28"
					x2="843.87"
					y2="561.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="843.87"
					y1="561.66"
					x2="846.97"
					y2="561.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.97"
					y1="561.29"
					x2="847.75"
					y2="561.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="847.75"
					y1="561.31"
					x2="848.37"
					y2="561.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.37"
					y1="561.64"
					x2="848.55"
					y2="562.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.55"
					y1="562.02"
					x2="849.78"
					y2="566.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.78"
					y1="566.33"
					x2="850.3"
					y2="570.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="850.3"
					y1="570.63"
					x2="850.3"
					y2="572.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="878.4"
					y1="572.04"
					x2="878.21"
					y2="570.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="878.21"
					y1="570.34"
					x2="877.77"
					y2="568.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.77"
					y1="568.7"
					x2="876.93"
					y2="566.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.93"
					y1="566.95"
					x2="875.55"
					y2="565.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.55"
					y1="565.33"
					x2="873.81"
					y2="564.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.81"
					y1="564.12"
					x2="871.84"
					y2="563.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.84"
					y1="563.22"
					x2="869.74"
					y2="562.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="869.74"
					y1="562.56"
					x2="866.34"
					y2="561.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.34"
					y1="561.97"
					x2="862.93"
					y2="562.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="862.93"
					y1="562.13"
					x2="860.28"
					y2="562.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="860.28"
					y1="562.9"
					x2="857.73"
					y2="564.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.73"
					y1="564.1"
					x2="855.44"
					y2="565.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.44"
					y1="565.53"
					x2="853.61"
					y2="566.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.77"
					y1="583.97"
					x2="850.74"
					y2="582.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="850.74"
					y1="582.91"
					x2="850.87"
					y2="582.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="850.87"
					y1="582.23"
					x2="851.42"
					y2="573.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="851.42"
					y1="573.48"
					x2="851.42"
					y2="572.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.77"
					y1="560.12"
					x2="850.74"
					y2="561.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="850.74"
					y1="561.17"
					x2="850.87"
					y2="561.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="850.87"
					y1="561.86"
					x2="851.42"
					y2="570.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="851.42"
					y1="570.61"
					x2="851.42"
					y2="572.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="842.52"
					y1="560.95"
					x2="842.2"
					y2="561.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="842.2"
					y1="561.34"
					x2="841.16"
					y2="563.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.16"
					y1="563.71"
					x2="840.96"
					y2="564.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="840.96 588.48 841.51 588.48 841.51 585.74 840.96 585.74 840.96 588.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="840.96"
					y1="585.74"
					x2="840.96"
					y2="588.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.51"
					y1="585.74"
					x2="840.96"
					y2="585.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.51"
					y1="588.48"
					x2="841.51"
					y2="585.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="840.96"
					y1="588.48"
					x2="841.51"
					y2="588.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="840.96"
					y1="558.35"
					x2="841.51"
					y2="558.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="841.51 587.38 845.97 587.38 845.97 586.83 841.51 586.83 841.51 587.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="841.51"
					y1="586.83"
					x2="841.51"
					y2="587.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="845.97"
					y1="586.83"
					x2="841.51"
					y2="586.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="845.97"
					y1="587.38"
					x2="845.97"
					y2="586.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.51"
					y1="587.38"
					x2="845.97"
					y2="587.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.51"
					y1="557.25"
					x2="845.97"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="844.6 586.83 845.7 586.83 845.7 557.25 844.6 557.25 844.6 586.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="844.6"
					y1="557.25"
					x2="844.6"
					y2="586.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="845.7"
					y1="557.25"
					x2="844.6"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="845.7"
					y1="586.83"
					x2="845.7"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.6"
					y1="586.83"
					x2="845.7"
					y2="586.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.47"
					y1="630.22"
					x2="806.47"
					y2="673.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.66"
					y1="630.22"
					x2="806.47"
					y2="630.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="801.35 635.38 801.35 668.05 730.14 668.05 730.14 635.38 801.35 635.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="801.35"
					y1="635.38"
					x2="801.35"
					y2="668.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="801.35"
					y1="668.05"
					x2="730.14"
					y2="668.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.14"
					y1="668.05"
					x2="730.14"
					y2="635.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.14"
					y1="635.38"
					x2="801.35"
					y2="635.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="794.35 652 794.37 651.71 794.44 651.42 794.56 651.16 794.71 650.92 794.91 650.71 795.13 650.54 795.38 650.41 795.64 650.34 795.91 650.31 796.18 650.34 796.45 650.41 796.69 650.54 796.92 650.71 797.11 650.92 797.26 651.16 797.38 651.42 797.45 651.71 797.47 652 797.45 652.3 797.38 652.58 797.26 652.85 797.11 653.09 796.92 653.3 796.69 653.47 796.45 653.59 796.18 653.67 795.91 653.69 795.64 653.67 795.38 653.59 795.13 653.47 794.91 653.3 794.71 653.09 794.56 652.85 794.44 652.58 794.37 652.3 794.35 652"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="794.35"
					y1="652"
					x2="794.37"
					y2="651.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.37"
					y1="651.71"
					x2="794.44"
					y2="651.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.44"
					y1="651.42"
					x2="794.56"
					y2="651.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.56"
					y1="651.16"
					x2="794.71"
					y2="650.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.71"
					y1="650.92"
					x2="794.91"
					y2="650.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.91"
					y1="650.71"
					x2="795.13"
					y2="650.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.13"
					y1="650.54"
					x2="795.38"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.38"
					y1="650.41"
					x2="795.64"
					y2="650.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.64"
					y1="650.34"
					x2="795.91"
					y2="650.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.91"
					y1="650.31"
					x2="796.18"
					y2="650.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="796.18"
					y1="650.34"
					x2="796.45"
					y2="650.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="796.45"
					y1="650.41"
					x2="796.69"
					y2="650.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="796.69"
					y1="650.54"
					x2="796.92"
					y2="650.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="796.92"
					y1="650.71"
					x2="797.11"
					y2="650.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="797.11"
					y1="650.92"
					x2="797.26"
					y2="651.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="797.26"
					y1="651.16"
					x2="797.38"
					y2="651.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="797.38"
					y1="651.42"
					x2="797.45"
					y2="651.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="797.45"
					y1="651.71"
					x2="797.47"
					y2="652"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="797.47"
					y1="652"
					x2="797.45"
					y2="652.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="797.45"
					y1="652.3"
					x2="797.38"
					y2="652.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="797.38"
					y1="652.58"
					x2="797.26"
					y2="652.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="797.26"
					y1="652.85"
					x2="797.11"
					y2="653.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="797.11"
					y1="653.09"
					x2="796.92"
					y2="653.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="796.92"
					y1="653.3"
					x2="796.69"
					y2="653.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="796.69"
					y1="653.47"
					x2="796.45"
					y2="653.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="796.45"
					y1="653.59"
					x2="796.18"
					y2="653.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="796.18"
					y1="653.67"
					x2="795.91"
					y2="653.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.91"
					y1="653.69"
					x2="795.64"
					y2="653.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.64"
					y1="653.67"
					x2="795.38"
					y2="653.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.38"
					y1="653.59"
					x2="795.13"
					y2="653.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.13"
					y1="653.47"
					x2="794.91"
					y2="653.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.91"
					y1="653.3"
					x2="794.71"
					y2="653.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.71"
					y1="653.09"
					x2="794.56"
					y2="652.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.56"
					y1="652.85"
					x2="794.44"
					y2="652.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.44"
					y1="652.58"
					x2="794.37"
					y2="652.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.37"
					y1="652.3"
					x2="794.35"
					y2="652"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="803.18 653.46 800.91 653.23 800.73 653.19 800.56 653.13 800.4 653.03 797.55 652.65 797.45 652.63 797.35 652.59 797.26 652.53 797.19 652.45 797.12 652.37 797.07 652.27 797.04 652.17 797.02 652.06 797.02 651.94 797.04 651.84 797.07 651.73 797.12 651.64 797.19 651.55 797.26 651.48 797.35 651.42 797.45 651.38 797.55 651.35 800.4 650.97 800.56 650.87 800.73 650.81 800.91 650.78 803.18 650.54 803.41 650.57 803.63 650.63 803.85 650.74 804.04 650.89 804.21 651.06 804.34 651.27 804.44 651.5 804.5 651.75 804.52 652 804.5 652.26 804.44 652.5 804.34 652.73 804.21 652.94 804.04 653.12 803.85 653.26 803.63 653.37 803.41 653.44 803.18 653.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="803.18"
					y1="653.46"
					x2="800.91"
					y2="653.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="800.4"
					y1="653.03"
					x2="797.55"
					y2="652.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="797.55"
					y1="651.35"
					x2="800.4"
					y2="650.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="800.91"
					y1="650.78"
					x2="803.18"
					y2="650.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="801.83"
					y1="651.21"
					x2="801.03"
					y2="651.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="801.03"
					y1="652.79"
					x2="801.83"
					y2="652.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="801.83"
					y1="652.79"
					x2="801.83"
					y2="651.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m800.91,653.23c-.18-.02-.36-.08-.51-.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m797.55,652.65c-.3-.04-.53-.32-.53-.65s.23-.61.53-.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m800.4,650.97c.15-.11.33-.17.51-.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m803.18,650.54c.75,0,1.35.65,1.35,1.46s-.6,1.46-1.35,1.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m801.03,652.79c-.4,0-.73-.35-.73-.79s.33-.79.73-.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m800.4,653.03c-.33-.22-.52-.62-.52-1.03s.2-.81.52-1.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="941.15 673.78 941.15 630.22 854.63 630.22 854.63 673.78 941.15 673.78"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="854.63"
					y1="673.78"
					x2="941.15"
					y2="673.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.63"
					y1="630.22"
					x2="854.63"
					y2="673.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="941.15"
					y1="630.22"
					x2="854.63"
					y2="630.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="941.15"
					y1="673.78"
					x2="941.15"
					y2="630.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.33"
					y1="671.09"
					x2="938.45"
					y2="671.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="938.45"
					y1="671.09"
					x2="938.45"
					y2="632.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="938.45"
					y1="632.92"
					x2="857.33"
					y2="632.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.33"
					y1="632.92"
					x2="857.33"
					y2="671.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.33"
					y1="671.09"
					x2="893.93"
					y2="653.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.33"
					y1="632.92"
					x2="893.93"
					y2="650.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="938.45"
					y1="671.09"
					x2="901.85"
					y2="653.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="938.45"
					y1="632.92"
					x2="901.85"
					y2="650.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="897.89"
					y1="654.7"
					x2="897.89"
					y2="649.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.59"
					y1="652"
					x2="895.19"
					y2="652"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m902.2,652c0-2.38-1.93-4.31-4.31-4.31s-4.31,1.93-4.31,4.31,1.93,4.32,4.31,4.32,4.31-1.93,4.31-4.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m900.59,652c0-1.49-1.21-2.69-2.7-2.69s-2.7,1.21-2.7,2.69,1.21,2.7,2.7,2.7,2.7-1.21,2.7-2.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="854.63 652 860.35 656.21 860.35 647.79 854.63 652"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="860.35"
					y1="647.79"
					x2="854.63"
					y2="652"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="860.35"
					y1="656.21"
					x2="860.35"
					y2="647.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.63"
					y1="652"
					x2="860.35"
					y2="656.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.66"
					y1="652"
					x2="865.17"
					y2="652"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="860.35"
					y1="652"
					x2="860.35"
					y2="647.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="860.35"
					y1="647.79"
					x2="854.63"
					y2="652"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="860.35"
					y1="652"
					x2="860.35"
					y2="656.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="860.35"
					y1="656.21"
					x2="854.63"
					y2="652"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.55"
					y1="650.76"
					x2="864.59"
					y2="649.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.55"
					y1="653.24"
					x2="864.59"
					y2="654.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="569.25 621.88 614.9 621.88 614.9 673.78 569.25 673.78 569.25 621.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="569.25"
					y1="621.88"
					x2="614.9"
					y2="621.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.9"
					y1="621.88"
					x2="614.9"
					y2="673.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.9"
					y1="673.78"
					x2="569.25"
					y2="673.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.25"
					y1="673.78"
					x2="569.25"
					y2="621.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.25"
					y1="625.31"
					x2="614.9"
					y2="625.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="684.94 569.81 716.2 569.81 716.2 539.1 684.94 539.1 684.94 569.81"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="684.94"
					y1="539.1"
					x2="684.94"
					y2="540.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.94"
					y1="542.29"
					x2="684.94"
					y2="545.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.94"
					y1="547.55"
					x2="684.94"
					y2="550.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.94"
					y1="552.81"
					x2="684.94"
					y2="556.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.94"
					y1="558.07"
					x2="684.94"
					y2="561.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.94"
					y1="563.33"
					x2="684.94"
					y2="566.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.94"
					y1="568.59"
					x2="684.94"
					y2="569.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.2"
					y1="539.1"
					x2="714.71"
					y2="539.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.73"
					y1="539.1"
					x2="709.45"
					y2="539.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.47"
					y1="539.1"
					x2="704.18"
					y2="539.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="702.21"
					y1="539.1"
					x2="698.93"
					y2="539.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.95"
					y1="539.1"
					x2="693.67"
					y2="539.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.69"
					y1="539.1"
					x2="688.41"
					y2="539.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.43"
					y1="539.1"
					x2="684.94"
					y2="539.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.2"
					y1="569.81"
					x2="716.2"
					y2="568.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.2"
					y1="566.62"
					x2="716.2"
					y2="563.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.2"
					y1="561.36"
					x2="716.2"
					y2="558.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.2"
					y1="556.1"
					x2="716.2"
					y2="552.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.2"
					y1="550.84"
					x2="716.2"
					y2="547.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.2"
					y1="545.58"
					x2="716.2"
					y2="542.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.2"
					y1="540.32"
					x2="716.2"
					y2="539.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.94"
					y1="569.81"
					x2="686.43"
					y2="569.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.41"
					y1="569.81"
					x2="691.69"
					y2="569.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.67"
					y1="569.81"
					x2="696.95"
					y2="569.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.93"
					y1="569.81"
					x2="702.21"
					y2="569.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.18"
					y1="569.81"
					x2="707.47"
					y2="569.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.45"
					y1="569.81"
					x2="712.73"
					y2="569.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.71"
					y1="569.81"
					x2="716.2"
					y2="569.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="683.32 539.21 682.38 539.21 682.38 569.69 683.32 569.69 683.32 564.91 682.55 564.91 682.55 543.99 683.32 543.99 683.32 539.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="683.32"
					y1="543.99"
					x2="683.32"
					y2="539.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="682.55"
					y1="543.99"
					x2="683.32"
					y2="543.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="682.55"
					y1="564.91"
					x2="682.55"
					y2="543.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="683.32"
					y1="564.91"
					x2="682.55"
					y2="564.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="683.32"
					y1="569.69"
					x2="683.32"
					y2="564.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="682.38"
					y1="569.69"
					x2="683.32"
					y2="569.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="682.38"
					y1="539.21"
					x2="682.38"
					y2="569.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="683.32"
					y1="539.21"
					x2="682.38"
					y2="539.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<polyline
					points="683.32 538.02 683.32 570.89 684.94 570.89 684.94 538.02 683.32 538.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="684.94"
					y1="538.02"
					x2="683.32"
					y2="538.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="684.94"
					y1="570.89"
					x2="684.94"
					y2="538.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="683.32"
					y1="570.89"
					x2="684.94"
					y2="570.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="683.32"
					y1="538.02"
					x2="683.32"
					y2="570.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="683.32"
					y1="569.69"
					x2="682.38"
					y2="569.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.38"
					y1="569.69"
					x2="682.38"
					y2="539.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.38"
					y1="539.21"
					x2="683.32"
					y2="539.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.32"
					y1="570.89"
					x2="683.32"
					y2="538.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.32"
					y1="543.99"
					x2="682.55"
					y2="543.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.55"
					y1="543.99"
					x2="682.55"
					y2="564.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.55"
					y1="564.91"
					x2="683.32"
					y2="564.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.94"
					y1="570.89"
					x2="683.32"
					y2="570.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.32"
					y1="538.02"
					x2="684.94"
					y2="538.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.94"
					y1="538.02"
					x2="684.94"
					y2="570.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="625.45 625.84 625.45 661.45 666.54 661.45 666.54 625.84 625.45 625.84"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="625.45"
					y1="625.84"
					x2="666.54"
					y2="625.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.45"
					y1="661.45"
					x2="666.54"
					y2="661.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.45"
					y1="660.38"
					x2="666.54"
					y2="660.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.45"
					y1="625.84"
					x2="625.45"
					y2="661.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.54"
					y1="625.84"
					x2="666.54"
					y2="661.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.14"
					y1="627.46"
					x2="663.84"
					y2="627.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.84"
					y1="627.46"
					x2="664.92"
					y2="628.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.92"
					y1="628.54"
					x2="664.92"
					y2="658.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.92"
					y1="658.76"
					x2="663.84"
					y2="659.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.84"
					y1="659.84"
					x2="628.14"
					y2="659.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.14"
					y1="659.84"
					x2="627.07"
					y2="658.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.07"
					y1="658.76"
					x2="627.07"
					y2="628.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.07"
					y1="628.54"
					x2="628.14"
					y2="627.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m641.11,634.75c0-2.98-2.41-5.39-5.39-5.39s-5.39,2.42-5.39,5.39,2.41,5.39,5.39,5.39,5.39-2.41,5.39-5.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m639.76,652.55c0-2.24-1.81-4.05-4.04-4.05s-4.05,1.81-4.05,4.05,1.81,4.04,4.05,4.04,4.04-1.81,4.04-4.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m660.31,634.75c0-2.24-1.81-4.05-4.04-4.05s-4.05,1.81-4.05,4.05,1.81,4.04,4.05,4.04,4.04-1.81,4.04-4.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m661.66,652.55c0-2.98-2.41-5.39-5.39-5.39s-5.39,2.42-5.39,5.39,2.41,5.39,5.39,5.39,5.39-2.41,5.39-5.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="688.88 575.37 688.88 609.48 689.2 610.25 689.96 610.56 712.8 610.56 713.56 610.25 713.88 609.48 713.88 575.37 713.56 574.61 712.8 574.29 689.96 574.29 689.2 574.61 688.88 575.37"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m688.88,575.37c0-.59.48-1.08,1.08-1.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.8"
					y1="574.29"
					x2="689.96"
					y2="574.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m712.8,574.29c.59,0,1.08.48,1.08,1.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.88"
					y1="609.48"
					x2="713.88"
					y2="575.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m713.88,609.48c0,.6-.48,1.08-1.08,1.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.96"
					y1="610.56"
					x2="712.8"
					y2="610.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m689.96,610.56c-.59,0-1.08-.48-1.08-1.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.88"
					y1="575.37"
					x2="688.88"
					y2="609.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.58"
					y1="578.07"
					x2="691.58"
					y2="606.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.65"
					y1="607.87"
					x2="707.41"
					y2="607.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.49"
					y1="606.79"
					x2="708.49"
					y2="578.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.41"
					y1="576.99"
					x2="692.65"
					y2="576.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.58"
					y1="578.07"
					x2="691.58"
					y2="578.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m692.65,607.87c-.59,0-1.08-.48-1.08-1.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m708.49,606.79c0,.59-.48,1.08-1.08,1.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m707.41,576.99c.6,0,1.08.48,1.08,1.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m691.58,578.07c0-.59.48-1.08,1.08-1.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m704.71,592.43c0-.89-.73-1.62-1.62-1.62s-1.62.72-1.62,1.62.72,1.62,1.62,1.62,1.62-.72,1.62-1.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="701.59 591.94 701.25 592.08 701.11 592.43 701.25 592.77 701.59 592.91 712.26 592.91 712.6 592.77 712.74 592.43 712.6 592.08 712.26 591.94 701.59 591.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="712.26"
					y1="591.94"
					x2="701.59"
					y2="591.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m712.26,591.94c.27,0,.48.22.48.48s-.22.49-.48.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.59"
					y1="592.91"
					x2="712.26"
					y2="592.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m701.59,592.91h0c-.27,0-.48-.22-.48-.49s.22-.48.48-.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="709.51 591.35 709.51 591.94 712.26 591.94 712.6 592.08 712.74 592.43 712.6 592.77 712.26 592.91 709.51 592.91 709.51 593.5 713.02 593.5 713.02 591.35 709.51 591.35"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="713.02"
					y1="591.35"
					x2="709.51"
					y2="591.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.02"
					y1="593.5"
					x2="713.02"
					y2="591.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.51"
					y1="593.5"
					x2="713.02"
					y2="593.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.51"
					y1="592.91"
					x2="709.51"
					y2="593.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.26"
					y1="592.91"
					x2="709.51"
					y2="592.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m712.26,591.94c.27,0,.48.22.48.48s-.22.49-.48.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.51"
					y1="591.94"
					x2="712.26"
					y2="591.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.51"
					y1="591.35"
					x2="709.51"
					y2="591.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="707.57 591.36 707.57 591.94 709.46 591.94 709.46 591.36 707.57 591.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="709.46"
					y1="591.36"
					x2="707.57"
					y2="591.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.46"
					y1="591.94"
					x2="709.46"
					y2="591.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.57"
					y1="591.94"
					x2="709.46"
					y2="591.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.57"
					y1="591.36"
					x2="707.57"
					y2="591.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="707.57 593.49 709.46 593.49 709.46 592.91 707.57 592.91 707.57 593.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="707.57"
					y1="592.91"
					x2="707.57"
					y2="593.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.46"
					y1="592.91"
					x2="707.57"
					y2="592.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.46"
					y1="593.49"
					x2="709.46"
					y2="592.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.57"
					y1="593.49"
					x2="709.46"
					y2="593.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.55"
					y1="646.51"
					x2="548.55"
					y2="636.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.55"
					y1="636.93"
					x2="522.53"
					y2="636.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.03"
					y1="646.51"
					x2="517.05"
					y2="646.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.05"
					y1="671.17"
					x2="554.03"
					y2="671.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.03"
					y1="671.17"
					x2="554.03"
					y2="634.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.05"
					y1="634.19"
					x2="517.05"
					y2="671.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.03"
					y1="634.87"
					x2="517.05"
					y2="634.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.53"
					y1="646.51"
					x2="522.53"
					y2="636.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.03"
					y1="634.19"
					x2="517.05"
					y2="634.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.94"
					y1="536.54"
					x2="717.82"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.53"
					y1="621.88"
					x2="613.53"
					y2="619.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.53"
					y1="619.18"
					x2="612.16"
					y2="619.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="612.16"
					y1="619.18"
					x2="612.16"
					y2="621.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.25"
					y1="628.58"
					x2="572.68"
					y2="628.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.65"
					y1="628.58"
					x2="577.94"
					y2="628.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.91"
					y1="628.58"
					x2="583.2"
					y2="628.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.17"
					y1="628.58"
					x2="588.46"
					y2="628.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.43"
					y1="628.58"
					x2="593.72"
					y2="628.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.69"
					y1="628.58"
					x2="598.98"
					y2="628.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.95"
					y1="628.58"
					x2="604.24"
					y2="628.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.21"
					y1="628.58"
					x2="609.5"
					y2="628.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.47"
					y1="628.58"
					x2="614.9"
					y2="628.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.74"
					y1="326.22"
					x2="884.84"
					y2="326.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.84"
					y1="315.26"
					x2="777.74"
					y2="315.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.07"
					y1="432.05"
					x2="576.23"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.23"
					y1="421.09"
					x2="659.07"
					y2="421.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.33"
					y1="432.05"
					x2="456.42"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.33"
					y1="421.09"
					x2="456.42"
					y2="421.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.42"
					y1="421.09"
					x2="456.42"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.94"
					y1="432.05"
					x2="209.23"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.23"
					y1="421.09"
					x2="300.94"
					y2="421.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m58.85,506.12c1.42-39.94,33.19-72.13,73.11-74.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m47.89,506.12v-.11c0-46.57,37.5-84.45,84.06-84.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.55"
					y1="667.06"
					x2="522.53"
					y2="667.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.53"
					y1="667.06"
					x2="522.53"
					y2="649.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.53"
					y1="649.25"
					x2="548.55"
					y2="649.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.55"
					y1="649.25"
					x2="548.55"
					y2="667.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="58.85 503.38 58.85 506.12 50.63 506.12 50.63 503.38 58.85 503.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="58.85"
					y1="503.38"
					x2="58.85"
					y2="506.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="58.85"
					y1="506.12"
					x2="50.63"
					y2="506.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="50.63"
					y1="506.12"
					x2="50.63"
					y2="503.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="50.63"
					y1="503.38"
					x2="58.85"
					y2="503.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="131.96 432.05 129.22 432.05 129.22 423.83 131.96 423.83 131.96 432.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="131.96"
					y1="432.05"
					x2="129.22"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="129.22"
					y1="432.05"
					x2="129.22"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="129.22"
					y1="423.83"
					x2="131.96"
					y2="423.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.96"
					y1="423.83"
					x2="131.96"
					y2="432.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.9"
					y1="645.02"
					x2="617.71"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.68"
					y1="645.02"
					x2="622.97"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.94"
					y1="645.02"
					x2="628.22"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.2"
					y1="645.02"
					x2="633.48"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.46"
					y1="645.02"
					x2="638.75"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.72"
					y1="645.02"
					x2="644"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.97"
					y1="645.02"
					x2="649.26"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.24"
					y1="645.02"
					x2="654.52"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.5"
					y1="645.02"
					x2="659.78"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.75"
					y1="645.02"
					x2="665.04"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.01"
					y1="645.02"
					x2="670.3"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.27"
					y1="645.02"
					x2="675.56"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.53"
					y1="645.02"
					x2="680.82"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.79"
					y1="645.02"
					x2="686.08"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.05"
					y1="645.02"
					x2="691.34"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.31"
					y1="645.02"
					x2="696.6"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.57"
					y1="645.02"
					x2="701.38"
					y2="645.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="645.02"
					x2="701.38"
					y2="641.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="639.76"
					x2="701.38"
					y2="636.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="634.5"
					x2="701.38"
					y2="631.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="629.24"
					x2="701.38"
					y2="625.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="623.98"
					x2="701.38"
					y2="620.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="618.72"
					x2="701.38"
					y2="615.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="613.46"
					x2="701.38"
					y2="610.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="608.2"
					x2="701.38"
					y2="604.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="602.94"
					x2="701.38"
					y2="599.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="597.68"
					x2="701.38"
					y2="594.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="592.42"
					x2="701.38"
					y2="589.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="587.16"
					x2="701.38"
					y2="583.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="581.91"
					x2="701.38"
					y2="578.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="576.64"
					x2="701.38"
					y2="573.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="571.38"
					x2="701.38"
					y2="568.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="566.13"
					x2="701.38"
					y2="562.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="560.87"
					x2="701.38"
					y2="557.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="555.6"
					x2="701.38"
					y2="552.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="550.35"
					x2="701.38"
					y2="547.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="545.09"
					x2="701.38"
					y2="541.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.38"
					y1="539.83"
					x2="701.38"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="952.11 315.26 952.11 684.74 502.8 684.74 502.8 661.37 502.31 661.37 502.31 650.41 506.91 650.41 506.91 628.63 514.99 628.63 514.99 635.47 513.76 635.47 513.76 673.78 557.32 673.78 557.32 635.47 556.08 635.47 556.08 628.63 569.25 628.63 569.25 673.78 614.9 673.78 614.9 661.45 717.82 661.45 717.82 536.54 731.07 536.54 731.07 543.39 724.66 543.39 724.66 673.78 806.47 673.78 806.47 630.22 824.17 630.22 824.17 543.39 774.9 543.39 774.9 536.54 802.13 536.54 802.13 528.98 808.97 528.98 808.97 536.54 890.04 536.54 890.04 543.39 840.96 543.39 840.96 630.22 854.63 630.22 854.63 673.78 941.15 673.78 941.15 543.39 933.87 543.39 933.87 536.54 941.15 536.54 941.15 326.22 884.84 326.22 884.84 315.26 952.11 315.26"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
				/>
				<polygon
					points="808.97 471.71 808.97 485.15 802.13 485.15 802.13 478.55 696.42 478.55 696.42 432.05 659.07 432.05 659.07 421.09 701.88 421.09 701.88 315.26 777.74 315.26 777.74 326.22 759.2 326.22 759.2 361.38 752.35 361.38 752.35 326.22 712.83 326.22 712.83 361.77 746.29 361.77 746.29 384.85 712.83 384.85 712.83 427.94 752.35 427.94 752.35 425.37 759.2 425.37 759.2 471.71 808.97 471.71"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
				/>
				<polygon
					points="458.48 650.41 458.48 661.37 273.52 661.37 273.52 623.47 47.89 623.47 47.89 506.12 58.85 506.12 58.85 575.01 68.14 575.01 68.14 612.52 284.48 612.52 284.48 650.41 366.65 650.41 366.65 643.87 373.5 643.87 373.5 650.41 458.48 650.41"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
				/>
				<polygon
					points="209.23 421.09 209.23 432.05 131.96 432.05 131.96 421.09 209.23 421.09 209.23 421.09"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
				/>
				<polygon
					points="403.33 421.09 403.33 440.17 373.5 440.17 373.5 600.04 366.65 600.04 366.65 566.96 325.44 566.96 325.44 549.7 332.29 549.7 332.29 560.11 366.65 560.11 366.65 477.64 332.29 477.64 332.29 485.5 325.44 485.5 325.44 432.05 300.94 432.05 300.94 421.09 403.33 421.09"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
				/>
				<polygon
					points="576.23 421.09 576.23 432.05 510.43 432.05 510.43 421.09 576.23 421.09 576.23 421.09"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
				/>
			</g>
			<g id="text">
				<path d="m590.07,651.64h-.89l-1.07-1.79c-.1-.17-.19-.31-.29-.42-.09-.12-.19-.22-.29-.29-.1-.07-.2-.13-.31-.16-.11-.04-.23-.05-.37-.05h-.62v2.72h-.75v-6.39h1.91c.28,0,.54.04.77.11.24.07.44.17.62.32.18.14.31.32.41.54.1.21.15.46.15.74,0,.22-.03.43-.1.62-.07.18-.16.35-.29.49-.12.15-.27.27-.45.37-.17.1-.37.18-.58.24v.02c.11.05.2.1.28.16.08.06.16.13.23.21.07.08.14.18.21.29.07.1.15.23.24.37l1.2,1.92Zm-3.83-5.72v2.32h1.02c.19,0,.36-.03.52-.08.16-.06.3-.14.41-.24.12-.11.21-.24.27-.39.07-.15.1-.33.1-.52,0-.34-.11-.61-.33-.8-.22-.19-.54-.29-.96-.29h-1.03Zm8.2,3.62h-3.22c.01.51.15.9.41,1.18.26.28.62.41,1.08.41.51,0,.99-.17,1.42-.51v.69c-.4.29-.93.44-1.59.44s-1.15-.21-1.52-.62c-.37-.42-.55-1-.55-1.75,0-.71.2-1.29.6-1.73.4-.45.91-.67,1.5-.67s1.06.19,1.39.58c.33.39.49.92.49,1.61v.38Zm-.75-.62c0-.42-.11-.75-.31-.99-.2-.23-.48-.35-.83-.35s-.64.12-.88.37-.39.57-.45.97h2.47Zm4.03-3.4c-.14-.08-.3-.12-.49-.12-.51,0-.77.32-.77.97v.7h1.07v.62h-1.07v3.94h-.73v-3.94h-.78v-.62h.78v-.74c0-.48.14-.86.41-1.13.28-.28.62-.42,1.03-.42.22,0,.4.03.53.08v.66Z" />
				<path d="m598.49,651.74c-.14,0-.25-.05-.35-.15-.1-.1-.14-.22-.14-.35s.05-.25.14-.35c.1-.1.22-.15.35-.15s.26.05.36.15c.1.1.15.22.15.35s-.05.25-.15.35c-.1.1-.22.15-.36.15Z" />
				<path d="m702.05,557.32v-6.35h2.19c.49,0,.87.03,1.13.09.36.08.67.24.93.45.33.28.58.65.75,1.09.17.44.25.94.25,1.51,0,.48-.06.91-.17,1.28-.11.37-.26.68-.43.93-.18.24-.37.43-.58.58-.21.14-.46.24-.76.32-.29.07-.63.11-1.02.11h-2.29Zm.84-.75h1.36c.42,0,.75-.04.98-.12.24-.08.43-.19.57-.33.2-.2.35-.47.46-.8.11-.34.17-.75.17-1.23,0-.66-.11-1.17-.33-1.53-.22-.36-.48-.6-.79-.72-.23-.09-.59-.13-1.09-.13h-1.33v4.85Zm6.68.75l-1.68-6.35h.86l.97,4.16c.1.44.19.87.27,1.3.16-.68.26-1.07.29-1.17l1.21-4.29h1.01l.91,3.21c.23.8.39,1.55.49,2.25.08-.4.19-.86.32-1.38l1-4.08h.84l-1.74,6.35h-.81l-1.34-4.84c-.11-.4-.18-.65-.2-.74-.07.29-.13.54-.19.74l-1.35,4.84h-.86Z" />
				<path d="m747.95,605.69v-9.93h2.83c.86,0,1.54.21,2.04.63.5.42.76.97.76,1.64,0,.56-.15,1.05-.46,1.47-.3.42-.73.71-1.26.89v.03c.67.08,1.21.33,1.61.76.4.42.6.98.6,1.66,0,.85-.3,1.54-.91,2.06-.61.53-1.38.79-2.31.79h-2.9Zm1.16-8.88v3.21h1.19c.64,0,1.14-.15,1.5-.46.36-.31.55-.74.55-1.3,0-.97-.64-1.45-1.91-1.45h-1.34Zm0,4.25v3.57h1.58c.68,0,1.21-.16,1.59-.48.38-.32.57-.77.57-1.33,0-1.17-.8-1.76-2.4-1.76h-1.34Zm11.89,4.63h-1.14v-1.11h-.03c-.49.85-1.22,1.27-2.18,1.27-.71,0-1.26-.19-1.66-.56-.4-.37-.6-.87-.6-1.49,0-1.33.78-2.1,2.34-2.31l2.13-.3c0-1.21-.49-1.81-1.46-1.81-.85,0-1.63.29-2.31.87v-1.16c.7-.44,1.5-.67,2.41-.67,1.67,0,2.5.88,2.5,2.65v4.61Zm-1.14-3.59l-1.71.24c-.53.07-.92.21-1.19.39-.27.18-.4.51-.4.99,0,.35.12.63.37.85.25.22.58.33.99.33.56,0,1.03-.2,1.39-.59.37-.4.55-.9.55-1.5v-.71Zm6.57,3.52c-.27.15-.62.22-1.06.22-1.24,0-1.86-.69-1.86-2.08v-4.2h-1.22v-.97h1.22v-1.73l1.14-.37v2.1h1.79v.97h-1.79v4c0,.48.08.82.24,1.02s.43.3.8.3c.29,0,.53-.08.74-.24v.97Zm7.4.07h-1.14v-4.09c0-1.48-.55-2.22-1.65-2.22-.55,0-1.02.21-1.4.64-.38.42-.57.97-.57,1.64v4.02h-1.14v-10.5h1.14v4.59h.03c.54-.9,1.32-1.34,2.33-1.34,1.6,0,2.4.96,2.4,2.89v4.37Z" />
				<path d="m484.24,529.37h-5.15v-9.93h1.16v8.88h3.99v1.05Zm1.95-8.89c-.2,0-.38-.07-.52-.21-.14-.14-.21-.31-.21-.53s.07-.39.21-.53c.14-.14.32-.21.52-.21s.38.07.53.21c.15.14.22.31.22.53s-.07.38-.22.52c-.14.14-.32.21-.53.21Zm.55,8.89h-1.14v-7.09h1.14v7.09Zm7.87-7.09l-2.83,7.09h-1.12l-2.69-7.09h1.25l1.8,5.15c.13.38.22.71.25.99h.03c.05-.36.12-.68.22-.96l1.88-5.18h1.2Zm1.79-1.8c-.2,0-.38-.07-.52-.21-.14-.14-.21-.31-.21-.53s.07-.39.21-.53c.14-.14.32-.21.52-.21s.38.07.53.21c.15.14.22.31.22.53s-.07.38-.22.52c-.14.14-.32.21-.53.21Zm.55,8.89h-1.14v-7.09h1.14v7.09Zm8.18,0h-1.14v-4.05c0-1.51-.55-2.26-1.65-2.26-.57,0-1.04.21-1.41.64-.37.42-.55.96-.55,1.61v4.05h-1.14v-7.09h1.14v1.18h.03c.54-.9,1.31-1.34,2.33-1.34.78,0,1.37.25,1.78.76.41.5.62,1.22.62,2.17v4.34Zm8.19-.57c0,2.6-1.25,3.91-3.74,3.91-.88,0-1.64-.17-2.3-.5v-1.14c.8.44,1.56.67,2.29.67,1.75,0,2.62-.93,2.62-2.78v-.78h-.03c-.54.91-1.35,1.36-2.44,1.36-.88,0-1.59-.31-2.13-.94-.54-.63-.8-1.48-.8-2.54,0-1.21.29-2.16.87-2.87.58-.71,1.38-1.07,2.38-1.07s1.66.38,2.13,1.15h.03v-.98h1.14v6.53Zm-1.14-2.64v-1.05c0-.56-.19-1.05-.57-1.45-.38-.4-.85-.6-1.42-.6-.7,0-1.25.26-1.65.77-.4.51-.6,1.22-.6,2.14,0,.79.19,1.42.57,1.9.38.47.89.71,1.52.71s1.15-.23,1.55-.68c.4-.45.6-1.03.6-1.74Z" />
				<polygon points="520.09 519.44 515.33 531.02 514.27 531.02 519.02 519.44 520.09 519.44" />
				<path d="m521.24,529.37v-9.93h2.74c3.5,0,5.25,1.61,5.25,4.84,0,1.53-.49,2.77-1.46,3.7-.97.93-2.27,1.39-3.9,1.39h-2.63Zm1.16-8.88v7.83h1.48c1.3,0,2.32-.35,3.04-1.05.73-.7,1.09-1.69,1.09-2.96,0-2.54-1.35-3.82-4.06-3.82h-1.55Zm9.16-.01c-.2,0-.38-.07-.52-.21-.14-.14-.21-.31-.21-.53s.07-.39.21-.53c.14-.14.32-.21.52-.21s.38.07.53.21c.15.14.22.31.22.53s-.07.38-.22.52c-.14.14-.32.21-.53.21Zm.55,8.89h-1.14v-7.09h1.14v7.09Zm8.14,0h-1.14v-4.05c0-1.51-.55-2.26-1.65-2.26-.57,0-1.04.21-1.41.64-.37.42-.55.96-.55,1.61v4.05h-1.14v-7.09h1.14v1.18h.03c.54-.9,1.31-1.34,2.33-1.34.78,0,1.37.25,1.78.76.41.5.62,1.22.62,2.17v4.34Zm2.68-8.89c-.2,0-.38-.07-.52-.21-.14-.14-.21-.31-.21-.53s.07-.39.21-.53c.14-.14.32-.21.52-.21s.38.07.53.21c.15.14.22.31.22.53s-.07.38-.22.52c-.14.14-.32.21-.53.21Zm.55,8.89h-1.14v-7.09h1.14v7.09Zm8.14,0h-1.14v-4.05c0-1.51-.55-2.26-1.65-2.26-.57,0-1.04.21-1.41.64-.37.42-.55.96-.55,1.61v4.05h-1.14v-7.09h1.14v1.18h.03c.54-.9,1.31-1.34,2.33-1.34.78,0,1.37.25,1.78.76.41.5.62,1.22.62,2.17v4.34Zm8.15-.57c0,2.6-1.25,3.91-3.74,3.91-.88,0-1.64-.17-2.3-.5v-1.14c.8.44,1.56.67,2.29.67,1.75,0,2.62-.93,2.62-2.78v-.78h-.03c-.54.91-1.35,1.36-2.44,1.36-.88,0-1.59-.31-2.13-.94-.54-.63-.8-1.48-.8-2.54,0-1.21.29-2.16.87-2.87.58-.71,1.38-1.07,2.38-1.07s1.66.38,2.13,1.15h.03v-.98h1.14v6.53Zm-1.14-2.64v-1.05c0-.56-.19-1.05-.58-1.45-.38-.4-.85-.6-1.42-.6-.7,0-1.25.26-1.65.77-.4.51-.6,1.22-.6,2.14,0,.79.19,1.42.57,1.9.38.47.89.71,1.52.71s1.15-.23,1.55-.68c.4-.45.6-1.03.6-1.74Z" />
				<path d="m573.36,529.37h-1.39l-1.66-2.78c-.15-.26-.3-.48-.44-.66-.14-.18-.29-.33-.44-.45-.15-.12-.31-.2-.48-.25-.17-.06-.36-.08-.58-.08h-.96v4.23h-1.16v-9.93h2.96c.43,0,.83.06,1.2.17.37.11.69.27.96.49.27.22.48.5.64.83.15.33.23.71.23,1.16,0,.35-.05.67-.16.96-.1.29-.25.54-.44.77-.19.23-.42.42-.69.58-.27.16-.57.28-.91.37v.03c.17.07.31.16.43.26.12.09.24.2.35.33.11.13.22.28.33.44.11.16.23.35.37.57l1.86,2.99Zm-5.96-8.88v3.6h1.58c.29,0,.56-.04.8-.13.25-.09.46-.21.64-.37.18-.17.32-.37.42-.6.1-.24.15-.51.15-.8,0-.53-.17-.94-.52-1.24-.34-.3-.84-.45-1.49-.45h-1.59Zm10.09,9.05c-1.05,0-1.89-.33-2.51-.99-.62-.67-.94-1.54-.94-2.64,0-1.19.33-2.12.98-2.79s1.53-1,2.64-1,1.88.33,2.47.98c.6.65.89,1.55.89,2.71s-.32,2.04-.96,2.72c-.64.68-1.49,1.02-2.57,1.02Zm.08-6.47c-.73,0-1.31.25-1.73.75-.42.49-.64,1.18-.64,2.05s.21,1.5.64,1.99c.43.48,1,.73,1.72.73s1.3-.24,1.69-.71c.4-.48.6-1.15.6-2.03s-.2-1.57-.6-2.05c-.39-.48-.96-.72-1.69-.72Zm8.18,6.47c-1.05,0-1.89-.33-2.51-.99-.62-.67-.94-1.54-.94-2.64,0-1.19.33-2.12.98-2.79.65-.67,1.53-1,2.64-1s1.88.33,2.47.98c.6.65.89,1.55.89,2.71s-.32,2.04-.96,2.72c-.64.68-1.49,1.02-2.57,1.02Zm.08-6.47c-.73,0-1.31.25-1.73.75-.42.49-.64,1.18-.64,2.05s.21,1.5.64,1.99c.43.48,1,.73,1.72.73s1.3-.24,1.69-.71c.4-.48.6-1.15.6-2.03s-.2-1.57-.6-2.05c-.39-.48-.96-.72-1.69-.72Zm15.29,6.3h-1.14v-4.07c0-.79-.12-1.35-.37-1.7-.24-.35-.65-.53-1.22-.53-.48,0-.9.22-1.24.67-.34.44-.51.97-.51,1.59v4.05h-1.14v-4.21c0-1.39-.54-2.09-1.61-2.09-.5,0-.91.21-1.23.63-.32.42-.48.96-.48,1.63v4.05h-1.14v-7.09h1.14v1.12h.03c.5-.86,1.24-1.29,2.2-1.29.48,0,.91.14,1.27.41.36.27.61.62.74,1.06.53-.98,1.31-1.47,2.36-1.47,1.56,0,2.34.96,2.34,2.89v4.37Z" />
				<path d="m512.41,544.09h-.83v-6.24c-.06.06-.16.14-.28.22-.12.08-.26.16-.41.24-.15.08-.31.16-.48.23-.17.07-.33.13-.49.17v-.84c.18-.05.37-.12.57-.2.2-.09.4-.18.6-.29.2-.11.38-.22.56-.33.17-.12.33-.23.45-.34h.31v7.38Zm6.98-4.04c0,.66-.07,1.25-.2,1.77-.13.51-.32.95-.57,1.31-.25.36-.56.63-.92.82-.36.18-.78.28-1.24.28s-.9-.08-1.26-.25v-.79c.4.22.83.34,1.28.34.33,0,.62-.07.87-.2.26-.13.48-.33.65-.58.18-.26.31-.58.41-.95.09-.38.14-.81.14-1.29h-.02c-.31.62-.85.93-1.61.93-.31,0-.59-.05-.85-.16-.26-.11-.48-.27-.67-.46-.19-.2-.33-.44-.44-.71-.1-.28-.16-.58-.16-.91,0-.36.06-.68.17-.98.12-.3.28-.55.48-.76.21-.21.45-.38.73-.5.29-.12.6-.18.93-.18.36,0,.68.07.96.22.28.14.52.36.71.64.19.28.34.62.44,1.03.1.41.15.88.15,1.4Zm-.89-.74c0-.28-.04-.53-.11-.76-.07-.23-.17-.42-.3-.58-.13-.16-.28-.29-.46-.38-.17-.09-.37-.14-.57-.14s-.38.04-.55.12c-.17.08-.32.19-.45.33-.12.14-.22.31-.3.51-.07.19-.11.41-.11.64,0,.26.03.48.1.68.07.2.17.37.3.51.13.14.28.24.46.32.18.07.38.11.6.11.19,0,.37-.04.54-.11.17-.07.32-.17.44-.29.13-.12.23-.27.3-.43.07-.17.11-.35.11-.54Z" />
				<rect x="520.72" y="536.87" width=".73" height="2.25" />
				<path d="m525.89,544.09h-.83v-6.24c-.06.06-.16.14-.28.22-.12.08-.26.16-.41.24-.15.08-.31.16-.48.23-.17.07-.33.13-.49.17v-.84c.18-.05.37-.12.57-.2.2-.09.4-.18.6-.29.2-.11.38-.22.56-.33.17-.12.33-.23.45-.34h.31v7.38Zm7.06-3.64c0,.6-.06,1.14-.17,1.61-.11.47-.27.86-.47,1.18-.2.32-.46.56-.76.73-.3.16-.64.25-1.02.25-.36,0-.69-.08-.97-.24-.28-.16-.52-.39-.71-.7-.19-.31-.34-.68-.44-1.12-.1-.45-.15-.96-.15-1.53,0-.63.05-1.19.16-1.67.11-.48.26-.89.47-1.21.2-.33.46-.58.76-.74.31-.17.65-.25,1.05-.25,1.51,0,2.27,1.23,2.27,3.7Zm-.85.08c0-2.05-.49-3.08-1.46-3.08-1.03,0-1.55,1.05-1.55,3.14,0,1.95.51,2.92,1.52,2.92s1.49-.99,1.49-2.98Z" />
				<path d="m534.93,536.87v2.25h-.73v-2.25h.73Zm1.67,0v2.25h-.73v-2.25h.73Z" />
				<path d="m544.85,538.93l-1.73,2.61,1.7,2.55h-.96l-1.01-1.67c-.06-.1-.14-.23-.23-.39h-.02s-.1.16-.24.39l-1.03,1.67h-.95l1.76-2.53-1.68-2.63h.96l1,1.76c.07.13.15.27.22.4h.02l1.29-2.16h.91Z" />
				<path d="m551.46,544.09h-.83v-6.24c-.06.06-.16.14-.28.22-.12.08-.26.16-.41.24-.15.08-.31.16-.48.23-.17.07-.33.13-.49.17v-.84c.18-.05.37-.12.57-.2.2-.09.4-.18.6-.29.2-.11.38-.22.56-.33.17-.12.33-.23.45-.34h.31v7.38Zm5.81-5.33c0-.22-.04-.41-.11-.58-.07-.16-.16-.3-.28-.41-.12-.11-.26-.19-.42-.25s-.34-.08-.52-.08c-.16,0-.32.02-.47.07s-.31.1-.45.18c-.14.08-.29.17-.42.28-.13.11-.26.23-.38.36v-.89c.23-.22.49-.4.78-.51.29-.12.64-.18,1.05-.18.3,0,.57.04.82.13.25.08.47.21.65.37.18.16.33.37.43.61.11.24.16.52.16.83,0,.29-.03.54-.1.78-.06.23-.16.45-.3.65-.13.2-.3.4-.5.59-.2.19-.44.38-.71.57-.34.24-.62.45-.84.62-.22.17-.39.33-.52.48-.13.15-.22.3-.27.45-.05.15-.08.32-.08.51h3.59v.74h-4.45v-.36c0-.31.03-.58.1-.82.07-.23.18-.46.33-.67.15-.21.36-.42.6-.63.25-.21.56-.45.92-.71.26-.19.48-.37.65-.54.18-.17.32-.34.43-.51.11-.17.18-.34.23-.52.05-.18.07-.37.07-.56Z" />
				<rect x="559.78" y="536.87" width=".73" height="2.25" />
				<path d="m566.43,540.45c0,.6-.06,1.14-.17,1.61-.11.47-.27.86-.47,1.18-.2.32-.46.56-.76.73-.3.16-.64.25-1.02.25-.36,0-.69-.08-.97-.24-.28-.16-.52-.39-.71-.7-.19-.31-.34-.68-.44-1.12-.1-.45-.15-.96-.15-1.53,0-.63.05-1.19.16-1.67.11-.48.26-.89.47-1.21.2-.33.46-.58.76-.74.31-.17.65-.25,1.05-.25,1.51,0,2.27,1.23,2.27,3.7Zm-.85.08c0-2.05-.49-3.08-1.46-3.08-1.03,0-1.55,1.05-1.55,3.14,0,1.95.51,2.92,1.52,2.92s1.5-.99,1.5-2.98Z" />
				<path d="m568.41,536.87v2.25h-.73v-2.25h.73Zm1.67,0v2.25h-.73v-2.25h.73Z" />
				<path d="m816.93,430.41v-9.93h2.83c.86,0,1.54.21,2.04.63.5.42.76.97.76,1.64,0,.56-.15,1.05-.46,1.47s-.73.71-1.26.89v.03c.67.08,1.21.33,1.61.76.4.42.6.98.6,1.66,0,.85-.3,1.54-.91,2.06-.61.53-1.38.79-2.31.79h-2.9Zm1.16-8.88v3.21h1.19c.64,0,1.14-.15,1.5-.46.36-.31.55-.74.55-1.3,0-.97-.64-1.45-1.9-1.45h-1.34Zm0,4.25v3.57h1.58c.68,0,1.21-.16,1.59-.48.38-.32.57-.77.57-1.33,0-1.17-.8-1.76-2.4-1.76h-1.34Zm12.5,1.36h-5.01c.02.79.23,1.4.64,1.83s.97.64,1.68.64c.8,0,1.53-.26,2.2-.79v1.07c-.62.45-1.45.68-2.47.68s-1.79-.32-2.36-.96c-.57-.65-.86-1.55-.86-2.72,0-1.1.31-2,.94-2.69.63-.7,1.41-1.05,2.33-1.05s1.65.3,2.15.9c.51.6.76,1.43.76,2.5v.6Zm-1.16-.96c0-.66-.16-1.17-.48-1.53-.31-.36-.74-.55-1.3-.55s-.99.19-1.36.57c-.37.38-.6.88-.69,1.5h3.83Zm8.92,4.23h-1.14v-1.21h-.03c-.53.91-1.34,1.37-2.44,1.37-.89,0-1.6-.32-2.14-.95-.53-.64-.8-1.5-.8-2.6,0-1.17.3-2.11.89-2.82.59-.71,1.38-1.06,2.36-1.06s1.68.38,2.13,1.15h.03v-4.39h1.14v10.5Zm-1.14-3.21v-1.05c0-.57-.19-1.06-.57-1.45-.38-.4-.86-.6-1.44-.6-.69,0-1.24.25-1.63.76-.4.51-.6,1.21-.6,2.11,0,.82.19,1.46.57,1.94.38.47.9.71,1.54.71s1.15-.23,1.54-.69c.4-.46.6-1.03.6-1.73Zm7.12-2.74c-.2-.15-.48-.23-.86-.23-.48,0-.89.23-1.22.69-.32.46-.48,1.08-.48,1.87v3.62h-1.14v-7.09h1.14v1.46h.03c.16-.5.41-.89.74-1.16.33-.28.7-.42,1.12-.42.3,0,.52.03.68.1v1.18Zm4.19,6.11c-1.05,0-1.89-.33-2.51-.99-.62-.67-.94-1.54-.94-2.64,0-1.19.33-2.12.98-2.79.65-.67,1.53-1,2.64-1s1.88.33,2.47.98c.6.65.89,1.55.89,2.71s-.32,2.04-.96,2.72c-.64.68-1.49,1.02-2.57,1.02Zm.08-6.47c-.73,0-1.31.25-1.73.75-.42.49-.64,1.18-.64,2.05s.21,1.5.64,1.99c.43.48,1,.73,1.72.73s1.3-.24,1.69-.71c.4-.48.6-1.15.6-2.03s-.2-1.57-.6-2.05c-.39-.48-.96-.72-1.69-.72Zm8.21,6.47c-1.05,0-1.89-.33-2.51-.99-.62-.67-.94-1.54-.94-2.64,0-1.19.33-2.12.98-2.79.65-.67,1.53-1,2.64-1s1.88.33,2.47.98c.6.65.89,1.55.89,2.71s-.32,2.04-.96,2.72c-.64.68-1.49,1.02-2.57,1.02Zm.08-6.47c-.73,0-1.31.25-1.73.75-.42.49-.64,1.18-.64,2.05s.21,1.5.64,1.99c.43.48,1,.73,1.72.73s1.3-.24,1.69-.71c.4-.48.6-1.15.6-2.03s-.2-1.57-.6-2.05c-.39-.48-.96-.72-1.69-.72Zm15.32,6.3h-1.14v-4.07c0-.79-.12-1.35-.37-1.7-.24-.35-.65-.53-1.22-.53-.48,0-.9.22-1.24.67-.34.44-.51.97-.51,1.59v4.05h-1.14v-4.21c0-1.39-.54-2.09-1.61-2.09-.5,0-.91.21-1.23.63-.32.42-.48.96-.48,1.63v4.05h-1.14v-7.09h1.14v1.12h.03c.5-.86,1.24-1.29,2.2-1.29.49,0,.91.14,1.27.41.36.27.61.62.74,1.06.53-.98,1.31-1.47,2.36-1.47,1.56,0,2.34.96,2.34,2.89v4.37Z" />
				<path d="m882.09,430.41h-1.14v-8.58c-.09.09-.22.19-.39.3-.17.11-.36.22-.57.33-.21.11-.43.21-.67.31-.23.1-.46.17-.68.23v-1.15c.25-.07.51-.16.79-.28.28-.12.56-.25.82-.39.27-.15.53-.3.77-.46.24-.16.45-.32.62-.47h.43v10.16Z" />
				<path d="m822.75,445.13h-.83v-6.24c-.06.06-.16.14-.28.22-.12.08-.26.16-.41.24-.15.08-.31.16-.48.23-.17.07-.33.13-.49.17v-.84c.18-.05.37-.12.57-.2.2-.09.4-.18.6-.29.2-.11.38-.22.56-.33.17-.12.33-.23.45-.34h.31v7.38Zm5.57,0h-.83v-6.24c-.06.06-.16.14-.28.22-.12.08-.26.16-.41.24-.15.08-.31.16-.48.23-.17.07-.33.13-.49.17v-.84c.18-.05.37-.12.57-.2.2-.09.4-.18.6-.29.2-.11.38-.22.56-.33.17-.12.33-.23.45-.34h.31v7.38Z" />
				<rect x="831.06" y="437.91" width=".73" height="2.25" />
				<path d="m836.22,445.13h-.83v-6.24c-.06.06-.16.14-.28.22-.12.08-.26.16-.41.24-.15.08-.31.16-.48.23-.17.07-.33.13-.49.17v-.84c.18-.05.37-.12.57-.2.2-.09.4-.18.6-.29.2-.11.38-.22.56-.33.17-.12.33-.23.45-.34h.31v7.38Z" />
				<path d="m839.7,437.91v2.25h-.73v-2.25h.73Zm1.67,0v2.25h-.73v-2.25h.73Z" />
				<path d="m849.62,439.97l-1.73,2.61,1.7,2.55h-.96l-1.01-1.67c-.06-.1-.14-.23-.23-.39h-.02s-.1.16-.24.39l-1.03,1.67h-.95l1.76-2.53-1.68-2.63h.96l1,1.76c.07.13.15.27.22.4h.02l1.29-2.16h.91Z" />
				<path d="m856.23,445.13h-.83v-6.24c-.06.06-.16.14-.28.22-.12.08-.26.16-.41.24-.15.08-.31.16-.48.23-.17.07-.33.13-.49.17v-.84c.18-.05.37-.12.57-.2.2-.09.4-.18.6-.29.2-.11.38-.22.56-.33.17-.12.33-.23.45-.34h.31v7.38Zm5.81-5.33c0-.22-.04-.41-.11-.58-.07-.16-.16-.3-.28-.41-.12-.11-.26-.19-.42-.25s-.34-.08-.52-.08c-.16,0-.32.02-.47.07s-.31.1-.45.18c-.14.08-.29.17-.42.28-.13.11-.26.23-.38.36v-.89c.23-.22.49-.4.78-.51.29-.12.64-.18,1.05-.18.3,0,.57.04.82.13.25.08.47.21.65.37.18.16.33.37.43.61.11.24.16.52.16.83,0,.29-.03.54-.1.78-.06.23-.16.45-.3.65-.13.2-.3.4-.5.59-.2.19-.44.38-.71.57-.34.24-.62.45-.84.62-.22.17-.39.33-.52.48-.13.15-.22.3-.27.45-.05.15-.08.32-.08.51h3.59v.74h-4.45v-.36c0-.31.03-.58.1-.82.07-.23.18-.46.33-.67s.36-.42.6-.63c.25-.21.56-.45.92-.71.26-.19.48-.37.65-.54.18-.17.32-.34.43-.51s.18-.34.23-.52c.05-.18.07-.37.07-.56Z" />
				<rect x="864.54" y="437.91" width=".73" height="2.25" />
				<path d="m869.7,445.13h-.83v-6.24c-.06.06-.16.14-.28.22-.12.08-.26.16-.41.24-.15.08-.31.16-.48.23-.17.07-.33.13-.49.17v-.84c.18-.05.37-.12.57-.2.2-.09.4-.18.6-.29.2-.11.38-.22.56-.33.17-.12.33-.23.45-.34h.31v7.38Zm7.06-3.64c0,.6-.06,1.14-.17,1.61-.11.47-.27.86-.47,1.18-.2.32-.46.56-.76.73-.3.16-.64.25-1.02.25-.36,0-.69-.08-.97-.24-.28-.16-.52-.39-.71-.7-.19-.31-.34-.68-.44-1.12-.1-.45-.15-.96-.15-1.53,0-.63.05-1.19.16-1.67.11-.48.26-.89.47-1.21.2-.33.46-.58.76-.74.31-.17.65-.25,1.05-.25,1.51,0,2.27,1.23,2.27,3.7Zm-.85.08c0-2.05-.49-3.08-1.46-3.08-1.03,0-1.55,1.05-1.55,3.14,0,1.95.51,2.92,1.52,2.92s1.49-.99,1.49-2.98Z" />
				<path d="m878.75,437.91v2.25h-.73v-2.25h.73Zm1.67,0v2.25h-.73v-2.25h.73Z" />
				<path d="m158.9,521.31v-9.93h2.83c.86,0,1.54.21,2.04.63.5.42.76.97.76,1.64,0,.56-.15,1.05-.46,1.47-.3.42-.73.71-1.26.89v.03c.67.08,1.21.33,1.61.76.4.42.6.98.6,1.66,0,.85-.3,1.54-.91,2.06-.61.53-1.38.79-2.31.79h-2.9Zm1.16-8.88v3.21h1.19c.64,0,1.14-.15,1.5-.46.36-.31.55-.74.55-1.3,0-.97-.64-1.45-1.91-1.45h-1.34Zm0,4.25v3.57h1.58c.68,0,1.21-.16,1.59-.48.38-.32.57-.77.57-1.33,0-1.17-.8-1.76-2.4-1.76h-1.34Zm12.5,1.36h-5.01c.02.79.23,1.4.64,1.83.41.43.97.64,1.68.64.8,0,1.53-.26,2.2-.79v1.07c-.62.45-1.45.68-2.47.68s-1.79-.32-2.36-.96c-.57-.65-.86-1.55-.86-2.72,0-1.1.31-2,.94-2.69.63-.7,1.41-1.05,2.33-1.05s1.65.3,2.15.9c.51.6.76,1.43.76,2.5v.6Zm-1.16-.96c0-.66-.16-1.17-.48-1.53-.31-.36-.74-.55-1.3-.55s-.99.19-1.36.57c-.37.38-.6.88-.69,1.5h3.83Zm8.92,4.23h-1.14v-1.21h-.03c-.53.91-1.34,1.37-2.44,1.37-.89,0-1.6-.32-2.14-.95-.53-.64-.8-1.5-.8-2.6,0-1.17.3-2.11.89-2.82.59-.71,1.38-1.06,2.36-1.06s1.68.38,2.13,1.15h.03v-4.39h1.14v10.5Zm-1.14-3.21v-1.05c0-.57-.19-1.06-.57-1.45s-.86-.6-1.44-.6c-.69,0-1.24.25-1.63.76-.4.51-.6,1.21-.6,2.11,0,.82.19,1.46.57,1.94.38.47.9.71,1.54.71s1.15-.23,1.54-.69c.4-.46.6-1.03.6-1.73Zm7.12-2.74c-.2-.15-.48-.23-.86-.23-.48,0-.89.23-1.22.69-.32.46-.48,1.08-.48,1.87v3.62h-1.14v-7.09h1.14v1.46h.03c.16-.5.41-.89.74-1.16.33-.28.7-.42,1.12-.42.3,0,.52.03.68.1v1.18Zm4.19,6.11c-1.05,0-1.89-.33-2.51-.99-.62-.67-.94-1.54-.94-2.64,0-1.19.33-2.12.98-2.79.65-.67,1.53-1,2.64-1s1.88.33,2.47.98c.6.65.89,1.55.89,2.71s-.32,2.04-.96,2.72c-.64.68-1.49,1.02-2.57,1.02Zm.08-6.47c-.73,0-1.31.25-1.73.75-.42.49-.64,1.18-.64,2.05s.21,1.5.64,1.99c.43.48,1,.73,1.72.73s1.3-.24,1.69-.71c.4-.48.6-1.15.6-2.03s-.2-1.57-.6-2.05c-.39-.48-.96-.72-1.69-.72Zm8.21,6.47c-1.05,0-1.89-.33-2.51-.99-.62-.67-.94-1.54-.94-2.64,0-1.19.33-2.12.98-2.79.65-.67,1.53-1,2.64-1s1.88.33,2.47.98c.6.65.89,1.55.89,2.71s-.32,2.04-.96,2.72c-.64.68-1.49,1.02-2.57,1.02Zm.08-6.47c-.73,0-1.31.25-1.73.75-.42.49-.64,1.18-.64,2.05s.21,1.5.64,1.99c.43.48,1,.73,1.72.73s1.3-.24,1.69-.71c.4-.48.6-1.15.6-2.03s-.2-1.57-.6-2.05c-.39-.48-.96-.72-1.69-.72Zm15.32,6.3h-1.14v-4.07c0-.79-.12-1.35-.37-1.7-.24-.35-.65-.53-1.22-.53-.48,0-.9.22-1.24.67-.34.44-.51.97-.51,1.59v4.05h-1.14v-4.21c0-1.39-.54-2.09-1.61-2.09-.5,0-.91.21-1.23.63-.32.42-.48.96-.48,1.63v4.05h-1.14v-7.09h1.14v1.12h.03c.5-.86,1.24-1.29,2.2-1.29.48,0,.91.14,1.27.41.36.27.61.62.74,1.06.53-.98,1.31-1.47,2.36-1.47,1.56,0,2.34.96,2.34,2.89v4.37Z" />
				<path d="m224.39,513.99c0-.3-.05-.57-.15-.8-.09-.23-.22-.41-.39-.56-.16-.15-.35-.27-.57-.34s-.46-.11-.72-.11c-.22,0-.44.03-.65.09-.21.06-.42.14-.62.25-.2.11-.39.23-.58.38-.18.15-.36.31-.52.49v-1.22c.32-.31.67-.54,1.07-.71.4-.17.88-.25,1.45-.25.41,0,.78.06,1.13.18.35.12.65.29.9.51.25.23.45.51.6.84.15.33.22.71.22,1.14,0,.39-.05.75-.14,1.07-.09.32-.22.62-.41.9-.18.28-.41.55-.69.81-.28.26-.6.52-.98.79-.47.33-.85.62-1.16.85-.3.24-.54.46-.72.67-.18.2-.3.41-.37.62-.07.2-.1.44-.1.71h4.95v1.02h-6.13v-.49c0-.42.05-.8.14-1.12.09-.32.24-.63.46-.92.21-.29.49-.58.83-.87.35-.29.77-.62,1.27-.98.36-.26.66-.51.9-.74.24-.24.44-.47.59-.71s.25-.47.31-.71c.06-.24.1-.5.1-.78Z" />
				<path d="m164.71,536.03h-.83v-6.24c-.06.06-.16.14-.28.22-.12.08-.26.16-.41.24-.15.08-.31.16-.48.23-.17.07-.33.13-.49.17v-.84c.18-.05.37-.12.57-.2.2-.09.4-.18.6-.29.2-.11.38-.22.56-.33.17-.12.33-.23.45-.34h.31v7.38Zm7.07-2.29c0,.35-.06.68-.17.97-.11.3-.27.55-.47.77-.2.21-.44.38-.72.5-.28.12-.58.18-.91.18-.36,0-.69-.08-.98-.23-.29-.15-.53-.37-.73-.65-.2-.29-.35-.63-.45-1.04-.1-.41-.16-.87-.16-1.38,0-.63.07-1.2.21-1.71.14-.51.34-.95.59-1.31.26-.37.57-.65.93-.85.36-.2.77-.3,1.21-.3.5,0,.9.07,1.2.21v.78c-.37-.19-.77-.29-1.18-.29-.32,0-.61.07-.87.22-.26.14-.48.35-.66.61-.18.26-.33.58-.43.95-.1.37-.15.79-.15,1.24h.02c.33-.6.88-.9,1.65-.9.32,0,.6.05.85.16.26.11.47.26.65.46.18.19.32.43.42.7s.15.57.15.91Zm-.85.11c0-.25-.03-.48-.1-.68-.06-.2-.16-.37-.28-.51-.12-.14-.26-.25-.44-.32-.17-.08-.37-.12-.59-.12-.2,0-.39.04-.57.12-.17.08-.33.18-.45.32-.13.13-.23.29-.3.46-.07.17-.11.36-.11.56,0,.25.04.48.11.7.07.21.17.4.3.56.13.16.28.29.45.38.18.09.37.14.59.14s.4-.04.57-.12c.17-.08.32-.19.44-.33s.21-.31.28-.5c.07-.2.1-.42.1-.65Z" />
				<rect x="173.03" y="528.81" width=".73" height="2.25" />
				<path d="m178.43,530.71c0-.22-.04-.41-.11-.58-.07-.16-.16-.3-.28-.41-.12-.11-.26-.19-.42-.25-.16-.05-.34-.08-.52-.08-.16,0-.32.02-.47.07-.15.04-.31.1-.45.18-.14.08-.29.17-.42.28-.13.11-.26.23-.38.36v-.89c.23-.22.49-.4.78-.51.29-.12.64-.18,1.05-.18.3,0,.57.04.82.13.25.08.47.21.65.37.18.16.33.37.43.61.11.24.16.52.16.83,0,.29-.03.54-.1.78-.06.23-.16.45-.3.65-.13.2-.3.4-.5.59-.2.19-.44.38-.71.57-.34.24-.62.45-.84.62-.22.17-.39.33-.52.48-.13.15-.22.3-.27.45-.05.15-.08.32-.08.51h3.59v.74h-4.45v-.36c0-.31.03-.58.1-.82.07-.23.18-.46.33-.67.15-.21.36-.42.6-.63.25-.21.56-.45.92-.71.26-.19.48-.37.65-.54.18-.17.32-.34.43-.51s.18-.34.23-.52c.05-.18.07-.37.07-.56Z" />
				<path d="m181.67,528.81v2.25h-.73v-2.25h.73Zm1.67,0v2.25h-.73v-2.25h.73Z" />
				<path d="m191.59,530.88l-1.73,2.61,1.7,2.55h-.96l-1.01-1.67c-.06-.1-.14-.23-.23-.39h-.02s-.1.16-.24.39l-1.03,1.67h-.95l1.76-2.53-1.68-2.63h.96l1,1.76c.07.13.15.27.22.4h.02l1.29-2.16h.91Z" />
				<path d="m198.2,536.03h-.83v-6.24c-.06.06-.16.14-.28.22-.12.08-.26.16-.41.24-.15.08-.31.16-.48.23-.17.07-.33.13-.49.17v-.84c.18-.05.37-.12.57-.2.2-.09.4-.18.6-.29.2-.11.38-.22.56-.33.17-.12.33-.23.45-.34h.31v7.38Zm7.06-3.64c0,.6-.06,1.14-.17,1.61-.11.47-.27.86-.47,1.18-.2.32-.46.56-.76.73-.3.16-.64.25-1.02.25-.36,0-.69-.08-.97-.24-.28-.16-.52-.39-.71-.7-.19-.31-.34-.68-.44-1.12-.1-.45-.15-.96-.15-1.53,0-.63.05-1.19.16-1.67.11-.48.26-.89.47-1.21.2-.33.46-.58.76-.74.31-.17.65-.25,1.05-.25,1.51,0,2.27,1.23,2.27,3.7Zm-.85.08c0-2.05-.49-3.08-1.46-3.08-1.03,0-1.55,1.05-1.55,3.14,0,1.95.51,2.92,1.52,2.92s1.5-.99,1.5-2.98Z" />
				<rect x="206.51" y="528.81" width=".73" height="2.25" />
				<path d="m211.67,536.03h-.83v-6.24c-.06.06-.16.14-.28.22-.12.08-.26.16-.41.24-.15.08-.31.16-.48.23-.17.07-.33.13-.49.17v-.84c.18-.05.37-.12.57-.2.2-.09.4-.18.6-.29.2-.11.38-.22.56-.33.17-.12.33-.23.45-.34h.31v7.38Zm5.57,0h-.83v-6.24c-.06.06-.16.14-.28.22-.12.08-.26.16-.41.24-.15.08-.31.16-.48.23-.17.07-.33.13-.49.17v-.84c.18-.05.37-.12.57-.2.2-.09.4-.18.6-.29.2-.11.38-.22.56-.33.17-.12.33-.23.45-.34h.31v7.38Z" />
				<path d="m220.72,528.81v2.25h-.73v-2.25h.73Zm1.67,0v2.25h-.73v-2.25h.73Z" />
				<path d="m612.11,589.77h-1.62l-3.84-4.54c-.14-.17-.23-.29-.26-.35h-.03v4.89h-1.16v-9.93h1.16v4.67h.03c.06-.1.15-.21.26-.34l3.71-4.33h1.45l-4.26,4.77,4.56,5.17Zm1.73-8.89c-.2,0-.38-.07-.52-.21-.14-.14-.21-.31-.21-.53s.07-.39.21-.53c.14-.14.32-.21.52-.21s.38.07.53.21c.15.14.22.31.22.53s-.07.38-.22.52c-.14.14-.32.21-.53.21Zm.55,8.89h-1.14v-7.09h1.14v7.09Zm5.58-.07c-.27.15-.62.22-1.06.22-1.24,0-1.86-.69-1.86-2.08v-4.2h-1.22v-.97h1.22v-1.73l1.14-.37v2.1h1.79v.97h-1.79v4c0,.48.08.82.24,1.02.16.2.43.3.8.3.29,0,.53-.08.74-.24v.97Zm6.34-.26c-.54.33-1.19.49-1.94.49-1.01,0-1.83-.33-2.45-.98-.62-.66-.93-1.51-.93-2.56,0-1.17.33-2.11,1-2.81.67-.71,1.56-1.07,2.68-1.07.62,0,1.17.12,1.65.35v1.16c-.53-.37-1.09-.55-1.69-.55-.73,0-1.32.26-1.79.78-.46.52-.69,1.2-.69,2.04s.22,1.49.65,1.97c.44.48,1.03.72,1.76.72.62,0,1.2-.21,1.75-.62v1.08Zm7.59.33h-1.14v-4.09c0-1.48-.55-2.22-1.65-2.22-.55,0-1.02.21-1.4.64-.38.42-.57.97-.57,1.64v4.02h-1.14v-10.5h1.14v4.59h.03c.54-.9,1.32-1.34,2.33-1.34,1.6,0,2.4.96,2.4,2.89v4.37Zm7.83-3.26h-5.01c.02.79.23,1.4.64,1.83.41.43.97.64,1.68.64.8,0,1.53-.26,2.2-.79v1.07c-.62.45-1.45.68-2.47.68s-1.79-.32-2.36-.96c-.57-.65-.86-1.55-.86-2.72,0-1.1.31-2,.94-2.69.63-.7,1.41-1.05,2.33-1.05s1.65.3,2.15.9c.51.6.76,1.43.76,2.5v.6Zm-1.16-.96c0-.66-.16-1.17-.48-1.53-.31-.36-.74-.55-1.3-.55s-.99.19-1.36.58-.61.88-.69,1.5h3.83Zm8.76,4.23h-1.14v-4.05c0-1.51-.55-2.26-1.65-2.26-.57,0-1.04.21-1.41.64-.37.42-.55.96-.55,1.61v4.05h-1.14v-7.09h1.14v1.18h.03c.54-.9,1.31-1.34,2.33-1.34.78,0,1.37.25,1.78.76.41.5.62,1.22.62,2.17v4.34Z" />
				<path d="m890.53,605.69v-9.93h2.83c.86,0,1.54.21,2.04.63.5.42.76.97.76,1.64,0,.56-.15,1.05-.46,1.47-.3.42-.73.71-1.26.89v.03c.67.08,1.21.33,1.61.76.4.42.6.98.6,1.66,0,.85-.3,1.54-.91,2.06-.61.53-1.38.79-2.31.79h-2.9Zm1.16-8.88v3.21h1.19c.64,0,1.14-.15,1.5-.46.36-.31.55-.74.55-1.3,0-.97-.64-1.45-1.91-1.45h-1.34Zm0,4.25v3.57h1.58c.68,0,1.21-.16,1.59-.48.38-.32.57-.77.57-1.33,0-1.17-.8-1.76-2.4-1.76h-1.34Zm11.89,4.63h-1.14v-1.11h-.03c-.49.85-1.22,1.27-2.18,1.27-.71,0-1.26-.19-1.66-.56-.4-.37-.6-.87-.6-1.49,0-1.33.78-2.1,2.34-2.31l2.13-.3c0-1.21-.49-1.81-1.46-1.81-.85,0-1.63.29-2.31.87v-1.16c.7-.44,1.5-.67,2.41-.67,1.67,0,2.5.88,2.5,2.65v4.61Zm-1.14-3.59l-1.71.24c-.53.07-.92.21-1.19.39-.27.18-.4.51-.4.99,0,.35.12.63.37.85.25.22.58.33.99.33.56,0,1.03-.2,1.39-.59.37-.4.55-.9.55-1.5v-.71Zm6.57,3.52c-.27.15-.62.22-1.06.22-1.24,0-1.86-.69-1.86-2.08v-4.2h-1.22v-.97h1.22v-1.73l1.14-.37v2.1h1.79v.97h-1.79v4c0,.48.08.82.24,1.02.16.2.43.3.8.3.29,0,.53-.08.74-.24v.97Zm7.4.07h-1.14v-4.09c0-1.48-.55-2.22-1.65-2.22-.55,0-1.02.21-1.4.64-.38.42-.57.97-.57,1.64v4.02h-1.14v-10.5h1.14v4.59h.03c.54-.9,1.32-1.34,2.33-1.34,1.6,0,2.4.96,2.4,2.89v4.37Z" />
				<path d="m346.21,373.09v3.75h-1.16v-9.93h2.73c1.06,0,1.88.26,2.47.78.59.52.88,1.25.88,2.19s-.33,1.71-.98,2.31c-.65.6-1.52.9-2.63.9h-1.31Zm0-5.13v4.07h1.22c.8,0,1.42-.18,1.84-.55.42-.37.64-.89.64-1.56,0-1.31-.78-1.97-2.33-1.97h-1.36Zm11.6,8.88h-1.14v-1.11h-.03c-.49.85-1.22,1.27-2.18,1.27-.71,0-1.26-.19-1.66-.56-.4-.37-.6-.87-.6-1.49,0-1.33.78-2.1,2.34-2.31l2.13-.3c0-1.21-.49-1.81-1.46-1.81-.85,0-1.63.29-2.31.87v-1.16c.7-.44,1.5-.67,2.41-.67,1.67,0,2.5.88,2.5,2.65v4.61Zm-1.14-3.59l-1.71.24c-.53.07-.92.21-1.19.39-.27.18-.4.51-.4.99,0,.35.12.63.37.85.25.22.58.33.99.33.56,0,1.03-.2,1.39-.59.37-.4.55-.9.55-1.5v-.71Zm6.46,3.52c-.27.15-.62.22-1.06.22-1.24,0-1.86-.69-1.86-2.08v-4.2h-1.22v-.97h1.22v-1.73l1.14-.37v2.1h1.79v.97h-1.79v4c0,.48.08.82.24,1.02.16.2.43.3.8.3.29,0,.53-.08.74-.24v.97Zm2-8.83c-.2,0-.38-.07-.52-.21-.14-.14-.21-.31-.21-.53s.07-.39.21-.53c.14-.14.32-.21.52-.21s.38.07.53.21c.15.14.22.31.22.53s-.07.38-.22.52c-.14.14-.32.21-.53.21Zm.55,8.89h-1.14v-7.09h1.14v7.09Zm5.16.17c-1.05,0-1.89-.33-2.51-.99-.62-.67-.94-1.54-.94-2.64,0-1.19.33-2.12.98-2.79.65-.67,1.53-1,2.64-1s1.88.33,2.47.98c.6.65.89,1.55.89,2.71s-.32,2.04-.96,2.72c-.64.68-1.49,1.02-2.57,1.02Zm.08-6.47c-.73,0-1.31.25-1.73.75-.42.49-.64,1.18-.64,2.05s.21,1.5.64,1.99c.43.48,1,.73,1.72.73s1.3-.24,1.69-.71c.4-.48.6-1.15.6-2.03s-.2-1.57-.6-2.05c-.39-.48-.96-.72-1.69-.72Z" />
				<polygon points="380.57 366.91 375.81 378.5 374.75 378.5 379.5 366.91 380.57 366.91" />
				<path d="m381.73,376.85v-9.93h2.83c.86,0,1.54.21,2.04.63.5.42.76.97.76,1.64,0,.56-.15,1.05-.46,1.47-.3.42-.73.71-1.26.89v.03c.67.08,1.21.33,1.61.76.4.42.6.98.6,1.66,0,.85-.3,1.54-.91,2.06-.61.53-1.38.79-2.31.79h-2.9Zm1.16-8.88v3.21h1.19c.64,0,1.14-.15,1.5-.46.36-.31.55-.74.55-1.3,0-.97-.64-1.45-1.91-1.45h-1.34Zm0,4.25v3.57h1.58c.68,0,1.21-.16,1.59-.48.38-.32.57-.77.57-1.33,0-1.17-.8-1.76-2.4-1.76h-1.34Zm11.88,4.63h-1.14v-1.11h-.03c-.49.85-1.22,1.27-2.18,1.27-.71,0-1.26-.19-1.66-.56-.4-.37-.6-.87-.6-1.49,0-1.33.78-2.1,2.34-2.31l2.13-.3c0-1.21-.49-1.81-1.46-1.81-.85,0-1.63.29-2.31.87v-1.16c.7-.44,1.5-.67,2.41-.67,1.67,0,2.5.88,2.5,2.65v4.61Zm-1.14-3.59l-1.71.24c-.53.07-.92.21-1.19.39-.27.18-.4.51-.4.99,0,.35.12.63.37.85.25.22.58.33.99.33.56,0,1.03-.2,1.39-.59.37-.4.55-.9.55-1.5v-.71Zm4.41,3.59h-1.14v-10.5h1.14v10.5Zm7.13-.33c-.54.33-1.19.49-1.94.49-1.01,0-1.83-.33-2.45-.98-.62-.66-.93-1.51-.93-2.56,0-1.17.33-2.11,1-2.81.67-.71,1.56-1.07,2.68-1.07.62,0,1.17.12,1.65.35v1.16c-.53-.37-1.09-.55-1.69-.55-.73,0-1.32.26-1.79.78-.46.52-.69,1.2-.69,2.04s.22,1.49.65,1.97c.44.48,1.03.72,1.76.72.62,0,1.2-.21,1.75-.62v1.08Zm4.68.49c-1.05,0-1.89-.33-2.51-.99-.62-.67-.94-1.54-.94-2.64,0-1.19.33-2.12.98-2.79.65-.67,1.53-1,2.64-1s1.88.33,2.47.98c.6.65.89,1.55.89,2.71s-.32,2.04-.96,2.72c-.64.68-1.49,1.02-2.57,1.02Zm.08-6.47c-.73,0-1.31.25-1.73.75-.42.49-.64,1.18-.64,2.05s.21,1.5.64,1.99,1,.73,1.72.73,1.3-.24,1.69-.71c.4-.48.6-1.15.6-2.03s-.2-1.57-.6-2.05c-.39-.48-.96-.72-1.69-.72Zm11.15,6.3h-1.14v-4.05c0-1.51-.55-2.26-1.65-2.26-.57,0-1.04.21-1.41.64-.37.42-.55.96-.55,1.61v4.05h-1.14v-7.09h1.14v1.18h.03c.54-.9,1.31-1.34,2.33-1.34.78,0,1.37.25,1.78.76.41.5.62,1.22.62,2.17v4.34Zm7.78-7.09l-3.26,8.23c-.58,1.47-1.4,2.2-2.45,2.2-.3,0-.54-.03-.74-.09v-1.02c.24.08.47.12.67.12.57,0,1-.34,1.29-1.03l.57-1.34-2.77-7.08h1.26l1.92,5.46c.02.07.07.25.15.54h.04c.02-.11.07-.29.14-.53l2.02-5.47h1.18Z" />
				<path d="m534.74,655.6l-1.78,6.31h-.87l-1.3-4.61c-.06-.2-.09-.41-.1-.64h-.02c-.02.22-.06.43-.11.63l-1.31,4.62h-.86l-1.85-6.31h.81l1.34,4.84c.06.2.09.41.11.63h.02c.01-.16.06-.37.14-.63l1.4-4.84h.71l1.34,4.88c.05.17.08.36.11.59h.02c.01-.15.05-.36.12-.61l1.29-4.86h.8Z" />
				<polygon points="538.43 655.6 535.4 662.96 534.73 662.96 537.75 655.6 538.43 655.6" />
				<path d="m539.16,661.92v-6.31h1.74c2.22,0,3.34,1.03,3.34,3.08,0,.97-.31,1.76-.93,2.35-.62.59-1.44.88-2.48.88h-1.67Zm.74-5.64v4.97h.94c.83,0,1.47-.22,1.93-.66.46-.44.69-1.07.69-1.88,0-1.62-.86-2.43-2.58-2.43h-.99Z" />
			</g>
		</g>
	)
}

export default PlanNN
